import React, { useEffect, useMemo, useState } from "react";
import axios from "../../api/axiosInstance";

const channexCardCss = `
  .chx-card {
    position: relative;
    border-radius: 18px;
    border: 1px solid transparent;
    background:
      linear-gradient(180deg, rgba(25, 25, 51, 0.9), rgba(10, 10, 22, 0.92)) padding-box,
      linear-gradient(135deg, rgba(48, 216, 255, 0.45), rgba(168, 85, 247, 0.5), rgba(255, 77, 79, 0.28)) border-box;
    box-shadow: 0 24px 56px rgba(0, 0, 0, 0.42);
    overflow: hidden;
    margin-top: 16px;
  }

  .chx-card--embedded {
    margin-top: 0;
  }

  .chx-card::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(700px 220px at 8% 0%, rgba(48, 216, 255, 0.1), transparent 60%),
      radial-gradient(540px 240px at 92% 10%, rgba(168, 85, 247, 0.12), transparent 62%);
    pointer-events: none;
    opacity: 0.92;
  }

  .chx-card > * {
    position: relative;
    z-index: 1;
  }

  .chx-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    padding: 18px 18px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  @media (max-width: 900px) {
    .chx-header {
      flex-direction: column;
    }
  }

  .chx-kicker {
    font-size: 0.74rem;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: rgba(48, 216, 255, 0.76);
    margin-bottom: 6px;
  }

  .chx-title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: 0.2px;
    color: transparent;
    background: linear-gradient(
      90deg,
      #e6e6f7 0%,
      rgba(48, 216, 255, 0.95) 40%,
      rgba(168, 85, 247, 0.95) 85%
    );
    -webkit-background-clip: text;
    background-clip: text;
  }

  .chx-subtitle {
    margin-top: 4px;
    color: rgba(230, 230, 247, 0.72);
    font-size: 0.86rem;
  }

  .chx-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 11px;
    border-radius: 999px;
    border: 1px solid rgba(48, 216, 255, 0.22);
    background: rgba(48, 216, 255, 0.1);
    color: rgba(168, 245, 255, 0.95);
    font-size: 0.78rem;
    font-weight: 700;
  }

  .chx-body {
    padding: 18px;
  }

  .chx-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
    margin-bottom: 12px;
  }

  .chx-stack {
    display: grid;
    gap: 16px;
  }

  .chx-chipRow {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .chx-btn {
    border-radius: 12px;
    padding: 10px 14px;
    font-size: 0.82rem;
    font-weight: 700;
    border: 1px solid transparent;
    cursor: pointer;
    transition: transform 120ms ease, box-shadow 120ms ease, border-color 120ms ease, background 120ms ease;
    color: #07131c;
    background: linear-gradient(135deg, rgba(48, 216, 255, 0.96), rgba(109, 236, 255, 0.92));
    box-shadow: 0 16px 30px rgba(48, 216, 255, 0.18);
  }

  .chx-btn:hover {
    transform: translateY(-1px);
  }

  .chx-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }

  .chx-btn--secondary {
    color: rgba(230, 230, 247, 0.9);
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(255, 255, 255, 0.12);
    box-shadow: none;
  }

  .chx-chip {
    display: inline-flex;
    align-items: center;
    padding: 7px 10px;
    border-radius: 999px;
    border: 1px solid rgba(255, 255, 255, 0.12);
    background: rgba(255, 255, 255, 0.05);
    color: rgba(230, 230, 247, 0.86);
    font-size: 0.76rem;
    font-weight: 700;
  }

  .chx-chip--success {
    border-color: rgba(72, 187, 120, 0.28);
    background: rgba(72, 187, 120, 0.12);
    color: #b9f5cf;
  }

  .chx-chip--muted {
    color: rgba(230, 230, 247, 0.68);
  }

  .chx-chip--error {
    border-color: rgba(255, 154, 154, 0.2);
    background: rgba(255, 90, 90, 0.1);
    color: #ffb0b0;
  }

  .chx-note {
    margin-bottom: 14px;
    color: rgba(230, 230, 247, 0.72);
    font-size: 0.84rem;
  }

  .chx-section {
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background:
      linear-gradient(180deg, rgba(15, 18, 39, 0.94), rgba(8, 10, 24, 0.95)) padding-box,
      linear-gradient(135deg, rgba(48, 216, 255, 0.12), rgba(168, 85, 247, 0.18), rgba(255, 77, 79, 0.1)) border-box;
    overflow: hidden;
  }

  .chx-sectionHeader {
    padding: 16px 18px 12px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .chx-sectionKicker {
    font-size: 0.68rem;
    text-transform: uppercase;
    letter-spacing: 0.16em;
    color: rgba(48, 216, 255, 0.7);
    margin-bottom: 5px;
  }

  .chx-sectionTitle {
    margin: 0;
    font-size: 1rem;
    font-weight: 800;
    color: rgba(230, 230, 247, 0.96);
  }

  .chx-sectionSubtitle {
    margin-top: 4px;
    font-size: 0.79rem;
    color: rgba(230, 230, 247, 0.64);
  }

  .chx-sectionBody {
    padding: 16px 18px 18px;
  }

  .chx-feedback {
    border-radius: 14px;
    padding: 14px 16px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(255, 255, 255, 0.04);
    color: rgba(230, 230, 247, 0.82);
  }

  .chx-feedback--error {
    border-color: rgba(255, 154, 154, 0.2);
    background: rgba(255, 90, 90, 0.1);
    color: #ffb0b0;
  }

  .chx-feedback--success {
    border-color: rgba(72, 187, 120, 0.22);
    background: rgba(72, 187, 120, 0.1);
    color: #c9f7d8;
  }

  .chx-table {
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    overflow: hidden;
    background: rgba(255, 255, 255, 0.03);
  }

  .chx-tableHeader,
  .chx-tableRow {
    display: grid;
    grid-template-columns: minmax(220px, 1.45fr) minmax(160px, 0.95fr) minmax(240px, 1.1fr) auto;
    gap: 12px;
    align-items: center;
  }

  .chx-tableHeader {
    padding: 12px 14px;
    background: rgba(255, 255, 255, 0.04);
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .chx-tableHeadCell {
    font-size: 0.67rem;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: rgba(48, 216, 255, 0.72);
    font-weight: 800;
  }

  .chx-tableRow {
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .chx-tableRow:last-child {
    border-bottom: none;
  }

  .chx-propertyCell {
    min-width: 0;
  }

  .chx-propertyLine {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }

  .chx-propertyName {
    font-size: 0.94rem;
    font-weight: 800;
    color: rgba(230, 230, 247, 0.96);
  }

  .chx-propertyId {
    font-size: 0.76rem;
    color: rgba(230, 230, 247, 0.62);
    margin-top: 4px;
  }

  .chx-metaText {
    font-size: 0.82rem;
    color: rgba(230, 230, 247, 0.76);
    line-height: 1.35;
  }

  .chx-tableTitle {
    font-size: 0.86rem;
    font-weight: 800;
    color: rgba(230, 230, 247, 0.96);
  }

  .chx-tableMeta {
    font-size: 0.78rem;
    color: rgba(230, 230, 247, 0.68);
    line-height: 1.45;
    margin-top: 4px;
  }

  .chx-currentMap {
    font-size: 0.79rem;
    color: rgba(230, 230, 247, 0.68);
    margin-bottom: 6px;
  }

  .chx-fieldLabel {
    display: block;
    margin-bottom: 6px;
    font-size: 0.66rem;
    text-transform: uppercase;
    letter-spacing: 0.14em;
    color: rgba(48, 216, 255, 0.72);
  }

  .chx-select {
    background: rgba(16, 16, 38, 0.88);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.12);
    min-height: 38px;
    font-size: 0.82rem;
  }

  .chx-input {
    background: rgba(16, 16, 38, 0.88);
    color: #ffffff;
    border: 1px solid rgba(255, 255, 255, 0.12);
    min-height: 38px;
    font-size: 0.82rem;
  }

  .chx-cellAction {
    display: flex;
    justify-content: flex-end;
  }

  .chx-inlineNote {
    margin-top: 6px;
    font-size: 0.76rem;
    color: rgba(230, 230, 247, 0.58);
  }

  .chx-inlineNote--error {
    margin-top: 10px;
    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid rgba(255, 154, 154, 0.18);
    background: rgba(255, 90, 90, 0.08);
    color: #ffb0b0;
    line-height: 1.45;
  }

  .chx-ariToolbar {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 12px;
    align-items: end;
    margin-bottom: 14px;
  }

  .chx-dateGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .chx-inventoryToolbar {
    display: grid;
    grid-template-columns: minmax(260px, 1fr) auto;
    gap: 12px;
    align-items: end;
    margin-bottom: 14px;
  }

  .chx-inventoryGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 14px;
  }

  .chx-miniPanel {
    border-radius: 14px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.04);
    overflow: hidden;
  }

  .chx-miniHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  }

  .chx-miniTitle {
    font-size: 0.86rem;
    font-weight: 800;
    color: rgba(230, 230, 247, 0.92);
  }

  .chx-miniHeaderActions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
    flex-wrap: wrap;
  }

  .chx-miniList {
    display: grid;
  }

  .chx-miniRow {
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .chx-miniRow--error {
    background: linear-gradient(180deg, rgba(255, 90, 90, 0.06), rgba(255, 90, 90, 0.02));
  }

  .chx-miniRow--pendingAck {
    background: linear-gradient(180deg, rgba(48, 216, 255, 0.08), rgba(48, 216, 255, 0.02));
  }

  .chx-miniRow:last-child {
    border-bottom: none;
  }

  .chx-miniRowTop {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }

  .chx-miniRowActions {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .chx-searchInput {
    min-width: 220px;
    max-width: 340px;
  }

  .chx-historyList {
    display: grid;
    gap: 8px;
    margin-top: 10px;
  }

  .chx-historyEntry {
    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
  }

  .chx-miniRowTitle {
    font-size: 0.84rem;
    font-weight: 700;
    color: rgba(230, 230, 247, 0.92);
  }

  .chx-miniRowMeta {
    margin-top: 5px;
    font-size: 0.77rem;
    color: rgba(230, 230, 247, 0.64);
    line-height: 1.4;
  }

  .chx-miniEmpty {
    padding: 14px;
    color: rgba(230, 230, 247, 0.68);
    font-size: 0.82rem;
  }

  .chx-mappingGrid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-top: 14px;
  }

  .chx-mapTable {
    display: grid;
  }

  .chx-mapHeader,
  .chx-mapRow {
    display: grid;
    grid-template-columns: minmax(190px, 1.1fr) minmax(170px, 0.92fr) minmax(230px, 1fr) auto;
    gap: 12px;
    align-items: center;
  }

  .chx-mapHeader {
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
  }

  .chx-mapRow {
    padding: 12px 14px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  }

  .chx-mapRow:last-child {
    border-bottom: none;
  }

  .chx-mapTitle {
    font-size: 0.84rem;
    font-weight: 700;
    color: rgba(230, 230, 247, 0.92);
  }

  .chx-mapMeta {
    margin-top: 5px;
    font-size: 0.77rem;
    color: rgba(230, 230, 247, 0.64);
    line-height: 1.4;
  }

  .chx-mapCurrent {
    font-size: 0.79rem;
    color: rgba(230, 230, 247, 0.76);
    line-height: 1.4;
  }

  .chx-mapCurrentName {
    font-weight: 700;
    color: rgba(230, 230, 247, 0.92);
  }

  .chx-mapCurrentMeta {
    margin-top: 4px;
    font-size: 0.75rem;
    color: rgba(230, 230, 247, 0.58);
  }

  .chx-mapAction {
    display: flex;
    justify-content: flex-end;
  }

  .chx-serviceTools {
    display: grid;
    gap: 14px;
    margin-bottom: 14px;
  }

  .chx-serviceFormGrid {
    display: grid;
    grid-template-columns: minmax(220px, 1.15fr) minmax(140px, 0.7fr) minmax(220px, 1fr) auto;
    gap: 12px;
    align-items: end;
  }

  @media (max-width: 1120px) {
    .chx-tableHeader,
    .chx-tableRow {
      grid-template-columns: minmax(220px, 1.5fr) minmax(220px, 1fr);
    }

    .chx-mappingGrid {
      grid-template-columns: 1fr;
    }

    .chx-mapHeader,
    .chx-mapRow {
      grid-template-columns: minmax(220px, 1.15fr) minmax(220px, 1fr);
    }

    .chx-cellAction {
      justify-content: flex-start;
    }

    .chx-mapAction {
      justify-content: flex-start;
    }

    .chx-serviceFormGrid {
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 760px) {
    .chx-tableHeader {
      display: none;
    }

    .chx-tableRow {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .chx-mapHeader {
      display: none;
    }

    .chx-mapRow {
      grid-template-columns: 1fr;
      gap: 10px;
    }

    .chx-serviceFormGrid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 980px) {
    .chx-ariToolbar,
    .chx-dateGrid,
    .chx-inventoryToolbar,
    .chx-inventoryGrid {
      grid-template-columns: 1fr;
    }
  }
`;

function buildPropertyDetailLine(property) {
  return [
    property.status || property.propertyStatus,
    property.currency || property.propertyCurrency,
    property.city || property.propertyCity,
    property.country || property.propertyCountry,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildMappedPropertyLabel(mapping) {
  return [mapping.propertyTitle, mapping.businessUnit?.name]
    .filter(Boolean)
    .join(" -> ");
}

function buildRoomTypeMeta(roomType) {
  return [
    roomType.defaultOccupancy != null ? `Default occupancy ${roomType.defaultOccupancy}` : null,
    roomType.countOfRooms != null ? `Rooms ${roomType.countOfRooms}` : null,
    roomType.roomKind ? `Kind ${roomType.roomKind}` : null,
    roomType.id ? `ID ${roomType.id}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildRatePlanMeta(ratePlan) {
  return [
    ratePlan.roomTypeTitle ? `Room type ${ratePlan.roomTypeTitle}` : null,
    ratePlan.occupancy != null ? `Occupancy ${ratePlan.occupancy}` : null,
    ratePlan.sellMode ? `Sell mode ${ratePlan.sellMode}` : null,
    ratePlan.rateMode ? `Rate mode ${ratePlan.rateMode}` : null,
    ratePlan.id ? `ID ${ratePlan.id}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildRoomCategoryMeta(roomCategory) {
  return [
    roomCategory.maxOccupancy != null ? `Max occupancy ${roomCategory.maxOccupancy}` : null,
    roomCategory.maxAdults != null ? `Adults ${roomCategory.maxAdults}` : null,
    roomCategory.maxChildren != null ? `Children ${roomCategory.maxChildren}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildRoomRateMeta(roomRate) {
  return [
    roomRate.roomCategoryName ? `Category ${roomRate.roomCategoryName}` : null,
    roomRate.status ? `Status ${roomRate.status}` : null,
    roomRate.rateCode ? `Code ${roomRate.rateCode}` : null,
    roomRate.maxOccupancy != null ? `Max occupancy ${roomRate.maxOccupancy}` : null,
    roomRate.id ? `ID ${roomRate.id}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildRoomRateOptionLabel(roomRate) {
  return [roomRate.name, roomRate.rateCode ? `(${roomRate.rateCode})` : null]
    .filter(Boolean)
    .join(" ");
}

function formatDateInputValue(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function buildRelativeDateInputValue(offsetDays = 0) {
  const nextDate = new Date();
  nextDate.setDate(nextDate.getDate() + Number(offsetDays || 0));
  return formatDateInputValue(nextDate);
}

function buildAvailabilitySyncWarningMeta(warning) {
  return [warning.roomTypeTitle, warning.roomCategoryName].filter(Boolean).join(" | ");
}

function buildAvailabilitySyncRoomTypeMeta(item) {
  return [
    item.roomCategoryName ? `Category ${item.roomCategoryName}` : null,
    item.syncedDatesCount != null ? `Days ${item.syncedDatesCount}` : null,
    item.payloadItemsCount != null ? `Payload ${item.payloadItemsCount}` : null,
    item.minAvailability != null ? `Min ${item.minAvailability}` : null,
    item.maxAvailability != null ? `Max ${item.maxAvailability}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildAvailabilityVerifyRoomTypeMeta(item) {
  return [
    item.roomCategoryName ? `Category ${item.roomCategoryName}` : null,
    item.matchedDatesCount != null ? `Matched ${item.matchedDatesCount}` : null,
    item.mismatchedDatesCount != null ? `Mismatched ${item.mismatchedDatesCount}` : null,
    item.missingRemoteDatesCount != null ? `Missing remote ${item.missingRemoteDatesCount}` : null,
    item.missingLocalDatesCount != null ? `Missing local ${item.missingLocalDatesCount}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildRestrictionsSyncRatePlanMeta(item) {
  return [
    item.roomRateTitle ? `Rate ${item.roomRateTitle}` : null,
    item.roomRateStatus ? `Status ${item.roomRateStatus}` : null,
    item.dateCount != null ? `Days ${item.dateCount}` : null,
    item.pricedDatesCount != null ? `Priced ${item.pricedDatesCount}` : null,
    item.stopSellDatesCount != null ? `Stop sell ${item.stopSellDatesCount}` : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function normalizeRemoteTasks(tasks) {
  if (!Array.isArray(tasks)) {
    return [];
  }

  return tasks
    .map((task, index) => {
      const id = String(task?.id || "").trim();
      if (!id) {
        return null;
      }

      return {
        id,
        type: String(task?.type || "task").trim(),
        key: `${String(task?.type || "task").trim()}-${id}-${index}`,
      };
    })
    .filter(Boolean);
}

function formatDateTimeLabel(value) {
  if (!value) {
    return "Never";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return "Never";
  }

  return parsed.toLocaleString();
}

function buildAutoSyncBatchMeta(batch) {
  return [
    batch.dateFrom && batch.dateTo ? `${batch.dateFrom} -> ${batch.dateTo}` : null,
    batch.roomTypesCount != null ? `Room types ${batch.roomTypesCount}` : null,
    batch.outboxRowsCount != null ? `Rows ${batch.outboxRowsCount}` : null,
    batch.payloadItemsCount != null ? `Payload ${batch.payloadItemsCount}` : null,
    batch.createdAt ? formatDateTimeLabel(batch.createdAt) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildStopSellBatchMeta(batch) {
  return [
    batch.dateFrom && batch.dateTo ? `${batch.dateFrom} -> ${batch.dateTo}` : null,
    batch.ratePlansCount != null ? `Rate plans ${batch.ratePlansCount}` : null,
    batch.outboxRowsCount != null ? `Rows ${batch.outboxRowsCount}` : null,
    batch.payloadItemsCount != null ? `Payload ${batch.payloadItemsCount}` : null,
    batch.createdAt ? formatDateTimeLabel(batch.createdAt) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildLosBatchMeta(batch) {
  return [
    batch.dateFrom && batch.dateTo ? `${batch.dateFrom} -> ${batch.dateTo}` : null,
    batch.ratePlansCount != null ? `Rate plans ${batch.ratePlansCount}` : null,
    batch.outboxRowsCount != null ? `Rows ${batch.outboxRowsCount}` : null,
    batch.payloadItemsCount != null ? `Payload ${batch.payloadItemsCount}` : null,
    batch.createdAt ? formatDateTimeLabel(batch.createdAt) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildPriceBatchMeta(batch) {
  return [
    batch.dateFrom && batch.dateTo ? `${batch.dateFrom} -> ${batch.dateTo}` : null,
    batch.ratePlansCount != null ? `Rate plans ${batch.ratePlansCount}` : null,
    batch.outboxRowsCount != null ? `Rows ${batch.outboxRowsCount}` : null,
    batch.payloadItemsCount != null ? `Payload ${batch.payloadItemsCount}` : null,
    batch.createdAt ? formatDateTimeLabel(batch.createdAt) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildPendingAriBatchMeta(batch) {
  return [
    Array.isArray(batch.selectedScopes) && batch.selectedScopes.length
      ? `Scopes ${batch.selectedScopes.join(", ")}`
      : null,
    batch.availabilityProcessed
      ? `Availability payload ${Number(batch.availabilityPayloadItemsCount || 0)}`
      : null,
    batch.restrictionsProcessed
      ? `Restrictions payload ${Number(batch.restrictionsPayloadItemsCount || 0)}`
      : null,
    batch.remoteTaskCount != null ? `Tasks ${batch.remoteTaskCount}` : null,
    batch.createdAt ? formatDateTimeLabel(batch.createdAt) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildBookingsBatchMeta(batch) {
  return [
    batch.source ? String(batch.source).toUpperCase() : null,
    batch.fetchedCount != null ? `Fetched ${batch.fetchedCount}` : null,
    batch.processedCount != null ? `Processed ${batch.processedCount}` : null,
    batch.importedCount != null ? `Imported ${batch.importedCount}` : null,
    batch.cancelledCount != null ? `Cancelled ${batch.cancelledCount}` : null,
    batch.ackedCount != null ? `Acked ${batch.ackedCount}` : null,
    batch.failedCount != null ? `Failed ${batch.failedCount}` : null,
    batch.finishedAt
      ? formatDateTimeLabel(batch.finishedAt)
      : batch.startedAt
        ? formatDateTimeLabel(batch.startedAt)
        : batch.createdAt
          ? formatDateTimeLabel(batch.createdAt)
          : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function buildBookingRevisionMeta(revision) {
  return [
    revision.otaName || null,
    revision.otaReservationCode ? `OTA ${revision.otaReservationCode}` : null,
    revision.bookingId ? `Booking ${revision.bookingId}` : null,
    revision.arrivalDate && revision.departureDate
      ? `${revision.arrivalDate} -> ${revision.departureDate}`
      : null,
    revision.totalAmount != null && revision.currency
      ? `${revision.totalAmount} ${revision.currency}`
      : revision.totalAmount != null
        ? String(revision.totalAmount)
        : null,
    revision.roomsCount != null ? `Rooms ${revision.roomsCount}` : null,
    revision.insertedAtRemote ? formatDateTimeLabel(revision.insertedAtRemote) : null,
  ]
    .filter(Boolean)
    .join(" | ");
}

function getBookingRevisionErrorStageLabel(revision) {
  const stage = String(revision?.errorStage || "").toLowerCase();

  if (stage === "ack") {
    return "Ack error";
  }

  if (stage === "import") {
    return "Import error";
  }

  if (String(revision?.ackStatus || "").toLowerCase() === "error") {
    return "Ack error";
  }

  if (String(revision?.importStatus || "").toLowerCase() === "error") {
    return "Import error";
  }

  return "Revision error";
}

function canRetryBookingRevision(revision) {
  if (!revision) {
    return false;
  }

  if (typeof revision.canRetry === "boolean") {
    return revision.canRetry;
  }

  return (
    String(revision.importStatus || "").toLowerCase() === "error" ||
    String(revision.ackStatus || "").toLowerCase() === "error"
  );
}

function canManuallyReprocessBookingRevision(revision) {
  if (!revision) {
    return false;
  }

  if (canRetryBookingRevision(revision)) {
    return true;
  }

  if (String(revision.ackStatus || "").toLowerCase() === "acked") {
    return false;
  }

  return (
    isWebhookTrackedOnlyBookingRevision(revision) ||
    isPendingAckBookingRevision(revision) ||
    ["pending", "processing"].includes(String(revision.importStatus || "").toLowerCase())
  );
}

function getBookingRevisionActionLabel(revision) {
  return isWebhookTrackedOnlyBookingRevision(revision) && !canRetryBookingRevision(revision)
    ? "Refetch"
    : "Retry";
}

function isPendingBookingRevision(revision) {
  if (!revision) {
    return false;
  }

  const importStatus = String(revision.importStatus || "").toLowerCase();
  const ackStatus = String(revision.ackStatus || "").toLowerCase();

  return ["pending", "processing"].includes(importStatus) || ackStatus === "pending";
}

function isPendingAckBookingRevision(revision) {
  if (!revision) {
    return false;
  }

  return String(revision.ackStatus || "").toLowerCase() === "pending";
}

function isWebhookTrackedOnlyBookingRevision(revision) {
  if (!revision) {
    return false;
  }

  if (typeof revision.isWebhookTrackedOnly === "boolean") {
    return revision.isWebhookTrackedOnly;
  }

  return String(revision.trackingSource || "").toLowerCase() === "webhook_stub";
}

function matchesBookingRevisionSearch(revision, query) {
  const normalizedQuery = String(query || "").trim().toLowerCase();

  if (!normalizedQuery) {
    return true;
  }

  const haystacks = [
    revision?.revisionId,
    revision?.bookingId,
    revision?.otaReservationCode,
    revision?.uniqueId,
    ...(Array.isArray(revision?.localReservationLocators) ? revision.localReservationLocators : []),
  ]
    .filter(Boolean)
    .map((value) => String(value).toLowerCase());

  return haystacks.some((value) => value.includes(normalizedQuery));
}

function escapeCsvCell(value) {
  const normalized = value == null ? "" : String(value);
  return `"${normalized.replace(/"/g, '""')}"`;
}

function downloadCsvFile(filename, headers, rows) {
  const csvRows = [
    headers.map(escapeCsvCell).join(","),
    ...rows.map((row) => row.map(escapeCsvCell).join(",")),
  ];
  const blob = new Blob(["\uFEFF", csvRows.join("\n")], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

function buildBookingRevisionHistorySummary(revision) {
  return Array.isArray(revision?.errorHistory)
    ? revision.errorHistory
        .map((entry) =>
          [
            entry?.at || null,
            entry?.stage || null,
            entry?.source || null,
            entry?.statusCode != null ? `HTTP ${entry.statusCode}` : null,
            entry?.message || null,
          ]
            .filter(Boolean)
            .join(" | ")
        )
        .filter(Boolean)
        .join(" || ")
    : "";
}

function getBookingRevisionChipClass(status) {
  switch (String(status || "").toLowerCase()) {
    case "imported":
    case "cancelled":
    case "acked":
      return "chx-chip--success";
    case "error":
      return "chx-chip--error";
    case "pending":
    case "processing":
      return "";
    default:
      return "chx-chip--muted";
  }
}

function getAutoSyncStatusChipClass(status) {
  switch (String(status || "").toLowerCase()) {
    case "sent":
    case "resolved":
    case "idle":
    case "completed":
    case "imported":
    case "cancelled":
    case "acked":
      return "chx-chip--success";
    case "error":
    case "completed_with_errors":
      return "chx-chip--error";
    case "disabled":
      return "chx-chip--muted";
    default:
      return "";
  }
}

function getAutoSyncCurrentStatus(autoSyncStatus) {
  if (!autoSyncStatus) {
    return "disabled";
  }

  if (!autoSyncStatus.enabled) {
    return "disabled";
  }

  if (Number(autoSyncStatus.processingRowsCount || 0) > 0) {
    return "processing";
  }

  if (Number(autoSyncStatus.pendingRowsCount || 0) > 0) {
    return "pending";
  }

  if (autoSyncStatus.latestBatch?.status) {
    return autoSyncStatus.latestBatch.status;
  }

  return autoSyncStatus.currentStatus || autoSyncStatus.status || "idle";
}

function getAutoSyncHistoricalErrorRowsCount(autoSyncStatus) {
  return Number(
    autoSyncStatus?.historicalErrorRowsCount ??
      autoSyncStatus?.errorRowsCount ??
      0
  );
}

const AUTO_SYNC_STATUS_POLL_MS = 15000;

function TaskIdsBlock({ tasks, title = "Certification Task IDs", style = undefined }) {
  const normalizedTasks = normalizeRemoteTasks(tasks);

  if (!normalizedTasks.length) {
    return null;
  }

  return (
    <div style={style}>
      <div className="chx-inlineNote" style={{ marginBottom: 6 }}>
        {title}
      </div>
      <div className="chx-chipRow">
        {normalizedTasks.map((task) => (
          <span
            className="chx-chip chx-chip--success"
            key={task.key}
            title={`${task.type} id`}
            style={{ wordBreak: "break-all" }}
          >
            {task.id}
          </span>
        ))}
      </div>
    </div>
  );
}

function ChannexIntegrationCard({ embedded = false, businessUnits = [] }) {
  const [properties, setProperties] = useState([]);
  const [mappings, setMappings] = useState([]);
  const [selectedBusinessUnitsByProperty, setSelectedBusinessUnitsByProperty] = useState({});
  const [selectedRoomCategoriesByRoomType, setSelectedRoomCategoriesByRoomType] = useState({});
  const [selectedRoomRatesByRatePlan, setSelectedRoomRatesByRatePlan] = useState({});
  const [loadingProperties, setLoadingProperties] = useState(false);
  const [loadingMappings, setLoadingMappings] = useState(false);
  const [savingPropertyId, setSavingPropertyId] = useState(null);
  const [savingRoomTypeId, setSavingRoomTypeId] = useState(null);
  const [savingRatePlanId, setSavingRatePlanId] = useState(null);
  const [propertiesError, setPropertiesError] = useState("");
  const [mappingsError, setMappingsError] = useState("");
  const [actionMessage, setActionMessage] = useState("");
  const [actionError, setActionError] = useState("");
  const [inventoryActionMessage, setInventoryActionMessage] = useState("");
  const [inventoryActionError, setInventoryActionError] = useState("");
  const [hasLoadedProperties, setHasLoadedProperties] = useState(false);
  const [selectedInventoryPropertyId, setSelectedInventoryPropertyId] = useState("");
  const [inventoryLoading, setInventoryLoading] = useState(false);
  const [inventoryError, setInventoryError] = useState("");
  const [inventoryData, setInventoryData] = useState(null);
  const [availabilityDateFrom, setAvailabilityDateFrom] = useState(() =>
    buildRelativeDateInputValue(0)
  );
  const [availabilityDateTo, setAvailabilityDateTo] = useState(() =>
    buildRelativeDateInputValue(30)
  );
  const [availabilitySyncing, setAvailabilitySyncing] = useState(false);
  const [availabilitySyncError, setAvailabilitySyncError] = useState("");
  const [availabilitySyncMessage, setAvailabilitySyncMessage] = useState("");
  const [availabilitySyncResult, setAvailabilitySyncResult] = useState(null);
  const [availabilityVerifying, setAvailabilityVerifying] = useState(false);
  const [availabilityVerifyError, setAvailabilityVerifyError] = useState("");
  const [availabilityVerifyMessage, setAvailabilityVerifyMessage] = useState("");
  const [availabilityVerifyResult, setAvailabilityVerifyResult] = useState(null);
  const [restrictionsSyncing, setRestrictionsSyncing] = useState(false);
  const [restrictionsSyncError, setRestrictionsSyncError] = useState("");
  const [restrictionsSyncMessage, setRestrictionsSyncMessage] = useState("");
  const [restrictionsSyncResult, setRestrictionsSyncResult] = useState(null);
  const [fullSyncing, setFullSyncing] = useState(false);
  const [fullSyncError, setFullSyncError] = useState("");
  const [fullSyncMessage, setFullSyncMessage] = useState("");
  const [fullSyncResult, setFullSyncResult] = useState(null);
  const [autoSyncLoading, setAutoSyncLoading] = useState(false);
  const [autoSyncUpdating, setAutoSyncUpdating] = useState(false);
  const [autoSyncSendingPending, setAutoSyncSendingPending] = useState(false);
  const [pendingAriSending, setPendingAriSending] = useState(false);
  const [pendingAriError, setPendingAriError] = useState("");
  const [pendingAriMessage, setPendingAriMessage] = useState("");
  const [pendingAriResult, setPendingAriResult] = useState(null);
  const [pendingAriRecentBatches, setPendingAriRecentBatches] = useState([]);
  const [selectedPendingAriScopes, setSelectedPendingAriScopes] = useState({
    availability: true,
    stop_sell: true,
    los: true,
    price: true,
  });
  const [autoSyncError, setAutoSyncError] = useState("");
  const [autoSyncMessage, setAutoSyncMessage] = useState("");
  const [autoSyncStatus, setAutoSyncStatus] = useState(null);
  const [stopSellAutoSyncLoading, setStopSellAutoSyncLoading] = useState(false);
  const [stopSellAutoSyncUpdating, setStopSellAutoSyncUpdating] = useState(false);
  const [stopSellAutoSyncSendingPending, setStopSellAutoSyncSendingPending] = useState(false);
  const [stopSellAutoSyncReconcilingErrors, setStopSellAutoSyncReconcilingErrors] = useState(false);
  const [stopSellAutoSyncError, setStopSellAutoSyncError] = useState("");
  const [stopSellAutoSyncMessage, setStopSellAutoSyncMessage] = useState("");
  const [stopSellAutoSyncStatus, setStopSellAutoSyncStatus] = useState(null);
  const [losAutoSyncLoading, setLosAutoSyncLoading] = useState(false);
  const [losAutoSyncUpdating, setLosAutoSyncUpdating] = useState(false);
  const [losAutoSyncSendingPending, setLosAutoSyncSendingPending] = useState(false);
  const [losAutoSyncError, setLosAutoSyncError] = useState("");
  const [losAutoSyncMessage, setLosAutoSyncMessage] = useState("");
  const [losAutoSyncStatus, setLosAutoSyncStatus] = useState(null);
  const [priceAutoSyncLoading, setPriceAutoSyncLoading] = useState(false);
  const [priceAutoSyncUpdating, setPriceAutoSyncUpdating] = useState(false);
  const [priceAutoSyncSendingPending, setPriceAutoSyncSendingPending] = useState(false);
  const [priceAutoSyncError, setPriceAutoSyncError] = useState("");
  const [priceAutoSyncMessage, setPriceAutoSyncMessage] = useState("");
  const [priceAutoSyncStatus, setPriceAutoSyncStatus] = useState(null);
  const [bookingsSyncLoading, setBookingsSyncLoading] = useState(false);
  const [bookingsSyncRunning, setBookingsSyncRunning] = useState(false);
  const [bookingsSyncUpdating, setBookingsSyncUpdating] = useState(false);
  const [bookingsSyncError, setBookingsSyncError] = useState("");
  const [bookingsSyncMessage, setBookingsSyncMessage] = useState("");
  const [bookingsSyncStatus, setBookingsSyncStatus] = useState(null);
  const [bookingsRetryingRevisionId, setBookingsRetryingRevisionId] = useState(null);
  const [bookingsRetryingAll, setBookingsRetryingAll] = useState(false);
  const [bookingsRevisionFilter, setBookingsRevisionFilter] = useState("all");
  const [bookingsRevisionQuery, setBookingsRevisionQuery] = useState("");
  const [expandedBookingErrorHistoryByRevision, setExpandedBookingErrorHistoryByRevision] =
    useState({});
  const [serviceMappingsLoading, setServiceMappingsLoading] = useState(false);
  const [serviceMappingsSavingId, setServiceMappingsSavingId] = useState(null);
  const [serviceMappingsCreating, setServiceMappingsCreating] = useState(false);
  const [serviceMappingsReapplying, setServiceMappingsReapplying] = useState(false);
  const [serviceMappingsError, setServiceMappingsError] = useState("");
  const [serviceMappingsMessage, setServiceMappingsMessage] = useState("");
  const [serviceMappingsStatus, setServiceMappingsStatus] = useState(null);
  const [manualServiceName, setManualServiceName] = useState("");
  const [manualServiceScope, setManualServiceScope] = useState("booking");
  const [manualServiceExtraId, setManualServiceExtraId] = useState("");

  const sortedBusinessUnits = useMemo(
    () =>
      [...businessUnits].sort((left, right) =>
        String(left?.name || "").localeCompare(String(right?.name || ""))
      ),
    [businessUnits]
  );

  const sortedProperties = useMemo(
    () =>
      [...properties].sort((left, right) =>
        String(left?.title || "").localeCompare(String(right?.title || ""))
      ),
    [properties]
  );

  const mappingsByProperty = useMemo(() => {
    const next = {};

    mappings.forEach((mapping) => {
      next[String(mapping.propertyId)] = mapping;
    });

    return next;
  }, [mappings]);

  const mappedProperties = useMemo(
    () =>
      [...mappings].sort((left, right) =>
        String(left?.propertyTitle || "").localeCompare(String(right?.propertyTitle || ""))
      ),
    [mappings]
  );

  const bookingsRecentRevisions = useMemo(
    () =>
      Array.isArray(bookingsSyncStatus?.recentRevisions)
        ? bookingsSyncStatus.recentRevisions
        : [],
    [bookingsSyncStatus?.recentRevisions]
  );

  const searchedBookingsRevisions = useMemo(
    () =>
      bookingsRecentRevisions.filter((revision) =>
        matchesBookingRevisionSearch(revision, bookingsRevisionQuery)
      ),
    [bookingsRecentRevisions, bookingsRevisionQuery]
  );

  const bookingsFailedRevisionsCount = useMemo(
    () => searchedBookingsRevisions.filter((revision) => canRetryBookingRevision(revision)).length,
    [searchedBookingsRevisions]
  );

  const bookingsPendingRevisionsCount = useMemo(
    () => searchedBookingsRevisions.filter((revision) => isPendingBookingRevision(revision)).length,
    [searchedBookingsRevisions]
  );

  const bookingsPendingAckRevisionsCount = useMemo(
    () =>
      searchedBookingsRevisions.filter((revision) => isPendingAckBookingRevision(revision)).length,
    [searchedBookingsRevisions]
  );

  const bookingsBulkReprocessableCount = useMemo(
    () =>
      bookingsRecentRevisions.filter((revision) => canManuallyReprocessBookingRevision(revision))
        .length,
    [bookingsRecentRevisions]
  );

  const filteredBookingsRevisions = useMemo(() => {
    if (bookingsRevisionFilter === "errors") {
      return searchedBookingsRevisions.filter((revision) => canRetryBookingRevision(revision));
    }

    if (bookingsRevisionFilter === "pending_ack") {
      return searchedBookingsRevisions.filter((revision) => isPendingAckBookingRevision(revision));
    }

    if (bookingsRevisionFilter === "pending") {
      return searchedBookingsRevisions.filter((revision) => isPendingBookingRevision(revision));
    }

    return searchedBookingsRevisions;
  }, [searchedBookingsRevisions, bookingsRevisionFilter]);

  const exportableBookingErrorRevisions = useMemo(
    () => searchedBookingsRevisions.filter((revision) => canRetryBookingRevision(revision)),
    [searchedBookingsRevisions]
  );

  const discoveredChannexServices = useMemo(
    () => (Array.isArray(serviceMappingsStatus?.services) ? serviceMappingsStatus.services : []),
    [serviceMappingsStatus?.services]
  );

  const serviceMappingExtras = useMemo(
    () => (Array.isArray(serviceMappingsStatus?.extras) ? serviceMappingsStatus.extras : []),
    [serviceMappingsStatus?.extras]
  );

  const inventoryRoomTypeMappingsByRoomType = useMemo(() => {
    const next = {};

    (inventoryData?.roomTypeMappings || []).forEach((mapping) => {
      next[String(mapping.roomTypeId)] = mapping;
    });

    return next;
  }, [inventoryData?.roomTypeMappings]);

  const inventoryRatePlanMappingsByRatePlan = useMemo(() => {
    const next = {};

    (inventoryData?.ratePlanMappings || []).forEach((mapping) => {
      next[String(mapping.ratePlanId)] = mapping;
    });

    return next;
  }, [inventoryData?.ratePlanMappings]);

  const mappedCount = mappings.length;
  const unmappedCount = Math.max(sortedProperties.length - mappedCount, 0);

  const loadProperties = async () => {
    setLoadingProperties(true);
    setPropertiesError("");

    try {
      const response = await axios.get("/api/integrations/channex/properties");
      const nextProperties = Array.isArray(response?.data?.properties)
        ? response.data.properties
        : [];

      setProperties(nextProperties);
      setHasLoadedProperties(true);
    } catch (requestError) {
      console.error("Error loading Channex properties:", requestError);
      setProperties([]);
      setHasLoadedProperties(true);
      setPropertiesError(
        requestError?.response?.data?.error || "Failed to load Channex properties."
      );
    } finally {
      setLoadingProperties(false);
    }
  };

  const loadMappings = async () => {
    setLoadingMappings(true);
    setMappingsError("");

    try {
      const response = await axios.get("/api/integrations/channex/property-mappings");
      const nextMappings = Array.isArray(response?.data?.mappings)
        ? response.data.mappings
        : [];

      setMappings(nextMappings);
    } catch (requestError) {
      console.error("Error loading Channex property mappings:", requestError);
      setMappings([]);
      setMappingsError(
        requestError?.response?.data?.error || "Failed to load Channex property mappings."
      );
    } finally {
      setLoadingMappings(false);
    }
  };

  const reloadInventory = async (propertyId = selectedInventoryPropertyId) => {
    if (!propertyId) {
      return;
    }

    setInventoryLoading(true);
    setInventoryError("");
    setInventoryActionError("");
    setAvailabilitySyncError("");
    setAvailabilitySyncMessage("");
    setAvailabilitySyncResult(null);
    setAvailabilityVerifyError("");
    setAvailabilityVerifyMessage("");
        setAvailabilityVerifyResult(null);
        setAutoSyncError("");
        setAutoSyncMessage("");
        setAutoSyncStatus(null);
        setPendingAriError("");
        setPendingAriMessage("");
        setPendingAriResult(null);
        setLosAutoSyncError("");
        setLosAutoSyncMessage("");
        setLosAutoSyncStatus(null);
        setPriceAutoSyncError("");
        setPriceAutoSyncMessage("");
        setPriceAutoSyncStatus(null);
        setStopSellAutoSyncError("");
        setStopSellAutoSyncMessage("");
        setStopSellAutoSyncStatus(null);

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/inventory`
      );
      setInventoryData(response.data);
      await refreshPropertyOperationalStatus(propertyId);
    } catch (requestError) {
      console.error("Error loading Channex inventory:", requestError);
      setInventoryData(null);
      setInventoryError(
        requestError?.response?.data?.error ||
          "Failed to load Channex inventory and Pilcore room data."
      );
    } finally {
      setInventoryLoading(false);
    }
  };

  const loadAutoSyncStatus = async (
    propertyId = selectedInventoryPropertyId,
    options = {}
  ) => {
    const { silent = false } = options;

    if (!propertyId) {
      setAutoSyncStatus(null);
      return;
    }

    if (!silent) {
      setAutoSyncLoading(true);
      setAutoSyncError("");
    }

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/availability/auto-sync`
      );
      setAutoSyncStatus(response.data?.autoSync || null);
    } catch (requestError) {
      console.error("Error loading Channex auto-sync status:", requestError);
      if (!silent) {
        setAutoSyncStatus(null);
        setAutoSyncError(
          requestError?.response?.data?.error ||
            "Failed to load Channex auto availability sync status."
        );
      }
    } finally {
      if (!silent) {
        setAutoSyncLoading(false);
      }
    }
  };

  const loadStopSellAutoSyncStatus = async (
    propertyId = selectedInventoryPropertyId,
    options = {}
  ) => {
    const { silent = false } = options;

    if (!propertyId) {
      setStopSellAutoSyncStatus(null);
      return;
    }

    if (!silent) {
      setStopSellAutoSyncLoading(true);
      setStopSellAutoSyncError("");
    }

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/stop-sell/auto-sync`
      );
      setStopSellAutoSyncStatus(response.data?.autoSync || null);
    } catch (requestError) {
      console.error("Error loading Channex stop-sell auto-sync status:", requestError);
      if (!silent) {
        setStopSellAutoSyncStatus(null);
        setStopSellAutoSyncError(
          requestError?.response?.data?.error ||
            "Failed to load Channex auto stop-sell sync status."
        );
      }
    } finally {
      if (!silent) {
        setStopSellAutoSyncLoading(false);
      }
    }
  };

  const loadLosAutoSyncStatus = async (
    propertyId = selectedInventoryPropertyId,
    options = {}
  ) => {
    const { silent = false } = options;

    if (!propertyId) {
      setLosAutoSyncStatus(null);
      return;
    }

    if (!silent) {
      setLosAutoSyncLoading(true);
      setLosAutoSyncError("");
    }

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/los/auto-sync`
      );
      setLosAutoSyncStatus(response.data?.autoSync || null);
    } catch (requestError) {
      console.error("Error loading Channex min/max stay auto-sync status:", requestError);
      if (!silent) {
        setLosAutoSyncStatus(null);
        setLosAutoSyncError(
          requestError?.response?.data?.error ||
            "Failed to load Channex auto min/max stay sync status."
        );
      }
    } finally {
      if (!silent) {
        setLosAutoSyncLoading(false);
      }
    }
  };

  const loadPriceAutoSyncStatus = async (
    propertyId = selectedInventoryPropertyId,
    options = {}
  ) => {
    const { silent = false } = options;

    if (!propertyId) {
      setPriceAutoSyncStatus(null);
      return;
    }

    if (!silent) {
      setPriceAutoSyncLoading(true);
      setPriceAutoSyncError("");
    }

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/prices/auto-sync`
      );
      setPriceAutoSyncStatus(response.data?.autoSync || null);
    } catch (requestError) {
      console.error("Error loading Channex price auto-sync status:", requestError);
      if (!silent) {
        setPriceAutoSyncStatus(null);
        setPriceAutoSyncError(
          requestError?.response?.data?.error ||
            "Failed to load Channex auto price sync status."
        );
      }
    } finally {
      if (!silent) {
        setPriceAutoSyncLoading(false);
      }
    }
  };

  const loadBookingsSyncStatus = async (propertyId = selectedInventoryPropertyId) => {
    if (!propertyId || stopSellAutoSyncSendingPending) {
      setBookingsSyncStatus(null);
      return;
    }

    setBookingsSyncLoading(true);
    setBookingsSyncError("");

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/bookings/auto-sync`
      );
      setBookingsSyncStatus(response.data || null);
    } catch (requestError) {
      console.error("Error loading Channex bookings status:", requestError);
      setBookingsSyncStatus(null);
      setBookingsSyncError(
        requestError?.response?.data?.error || "Failed to load Channex bookings status."
      );
    } finally {
      setBookingsSyncLoading(false);
    }
  };

  const loadServiceMappings = async (propertyId = selectedInventoryPropertyId) => {
    if (!propertyId || losAutoSyncSendingPending) {
      setServiceMappingsStatus(null);
      return;
    }

    setServiceMappingsLoading(true);
    setServiceMappingsError("");

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/services/mappings`
      );
      setServiceMappingsStatus(response.data || null);
    } catch (requestError) {
      console.error("Error loading Channex service mappings:", requestError);
      setServiceMappingsStatus(null);
      setServiceMappingsError(
        requestError?.response?.data?.error || "Failed to load Channex service mappings."
      );
    } finally {
      setServiceMappingsLoading(false);
    }
  };

  const refreshPropertyOperationalStatus = async (propertyId = selectedInventoryPropertyId) => {
    if (!propertyId) {
      return;
    }

    await Promise.allSettled([
      loadAutoSyncStatus(propertyId),
      loadLosAutoSyncStatus(propertyId),
      loadPriceAutoSyncStatus(propertyId),
      loadStopSellAutoSyncStatus(propertyId),
      loadBookingsSyncStatus(propertyId),
      loadServiceMappings(propertyId),
    ]);
  };

  useEffect(() => {
    loadProperties();
    loadMappings();
  }, []);

  useEffect(() => {
    const nextSelections = {};

    sortedProperties.forEach((property) => {
      const currentMapping = mappingsByProperty[String(property.id)];
      nextSelections[String(property.id)] = currentMapping?.businessUnitId
        ? String(currentMapping.businessUnitId)
        : "";
    });

    setSelectedBusinessUnitsByProperty(nextSelections);
  }, [sortedProperties, mappingsByProperty]);

  useEffect(() => {
    if (mappedProperties.length === 0) {
      setSelectedInventoryPropertyId("");
      setInventoryData(null);
      setInventoryError("");
      setInventoryActionMessage("");
      setInventoryActionError("");
      setAvailabilitySyncError("");
      setAvailabilitySyncMessage("");
      setAvailabilitySyncResult(null);
      setAvailabilityVerifyError("");
      setAvailabilityVerifyMessage("");
      setAvailabilityVerifyResult(null);
      setRestrictionsSyncError("");
      setRestrictionsSyncMessage("");
      setRestrictionsSyncResult(null);
      setFullSyncError("");
      setFullSyncMessage("");
      setFullSyncResult(null);
      setAutoSyncError("");
      setAutoSyncMessage("");
      setAutoSyncStatus(null);
      setLosAutoSyncError("");
      setLosAutoSyncMessage("");
      setLosAutoSyncStatus(null);
      setPriceAutoSyncError("");
      setPriceAutoSyncMessage("");
      setPriceAutoSyncStatus(null);
      setStopSellAutoSyncError("");
      setStopSellAutoSyncMessage("");
      setStopSellAutoSyncStatus(null);
      setBookingsSyncError("");
      setBookingsSyncMessage("");
      setBookingsSyncStatus(null);
      setBookingsRetryingRevisionId(null);
      setBookingsRetryingAll(false);
      setBookingsRevisionFilter("all");
      setBookingsRevisionQuery("");
      setExpandedBookingErrorHistoryByRevision({});
      setServiceMappingsLoading(false);
      setServiceMappingsSavingId(null);
      setServiceMappingsCreating(false);
      setServiceMappingsReapplying(false);
      setServiceMappingsError("");
      setServiceMappingsMessage("");
      setServiceMappingsStatus(null);
      setManualServiceName("");
      setManualServiceScope("booking");
      setManualServiceExtraId("");
      return;
    }

    const mappedPropertyIds = mappedProperties.map((mapping) => String(mapping.propertyId));

    if (!mappedPropertyIds.includes(String(selectedInventoryPropertyId || ""))) {
      setSelectedInventoryPropertyId(mappedPropertyIds[0]);
      setInventoryData(null);
      setInventoryError("");
      setInventoryActionMessage("");
      setInventoryActionError("");
      setAvailabilitySyncError("");
      setAvailabilitySyncMessage("");
      setAvailabilitySyncResult(null);
      setAvailabilityVerifyError("");
      setAvailabilityVerifyMessage("");
      setAvailabilityVerifyResult(null);
      setRestrictionsSyncError("");
      setRestrictionsSyncMessage("");
      setRestrictionsSyncResult(null);
      setFullSyncError("");
      setFullSyncMessage("");
      setFullSyncResult(null);
      setAutoSyncError("");
      setAutoSyncMessage("");
      setAutoSyncStatus(null);
      setLosAutoSyncError("");
      setLosAutoSyncMessage("");
      setLosAutoSyncStatus(null);
      setPriceAutoSyncError("");
      setPriceAutoSyncMessage("");
      setPriceAutoSyncStatus(null);
      setStopSellAutoSyncError("");
      setStopSellAutoSyncMessage("");
      setStopSellAutoSyncStatus(null);
      setBookingsSyncError("");
      setBookingsSyncMessage("");
      setBookingsSyncStatus(null);
      setBookingsRetryingRevisionId(null);
      setBookingsRetryingAll(false);
      setBookingsRevisionFilter("all");
      setBookingsRevisionQuery("");
      setExpandedBookingErrorHistoryByRevision({});
      setServiceMappingsLoading(false);
      setServiceMappingsSavingId(null);
      setServiceMappingsCreating(false);
      setServiceMappingsReapplying(false);
      setServiceMappingsError("");
      setServiceMappingsMessage("");
      setServiceMappingsStatus(null);
      setManualServiceName("");
      setManualServiceScope("booking");
      setManualServiceExtraId("");
    }
  }, [mappedProperties, selectedInventoryPropertyId]);

  useEffect(() => {
    if (!selectedInventoryPropertyId) {
      setAutoSyncStatus(null);
      setPendingAriError("");
      setPendingAriMessage("");
      setPendingAriResult(null);
      setLosAutoSyncStatus(null);
      setPriceAutoSyncStatus(null);
      setStopSellAutoSyncStatus(null);
      setBookingsSyncError("");
      setBookingsSyncMessage("");
      setBookingsSyncStatus(null);
      setBookingsRetryingRevisionId(null);
      setBookingsRetryingAll(false);
      setBookingsRevisionFilter("all");
      setBookingsRevisionQuery("");
      setExpandedBookingErrorHistoryByRevision({});
      setRestrictionsSyncError("");
      setRestrictionsSyncMessage("");
      setRestrictionsSyncResult(null);
      setFullSyncError("");
      setFullSyncMessage("");
      setFullSyncResult(null);
      setServiceMappingsCreating(false);
      setServiceMappingsReapplying(false);
      setServiceMappingsError("");
      setServiceMappingsMessage("");
      setServiceMappingsStatus(null);
      setManualServiceName("");
      setManualServiceScope("booking");
      setManualServiceExtraId("");
      return;
    }

    setBookingsSyncMessage("");
    setServiceMappingsMessage("");
    setPendingAriError("");
    setPendingAriMessage("");
    setPendingAriResult(null);
    refreshPropertyOperationalStatus(selectedInventoryPropertyId);
  }, [selectedInventoryPropertyId]);

  useEffect(() => {
    if (!selectedInventoryPropertyId) {
      return undefined;
    }

    const refreshStatusesSilently = () => {
      loadAutoSyncStatus(selectedInventoryPropertyId, { silent: true });
      loadLosAutoSyncStatus(selectedInventoryPropertyId, { silent: true });
      loadPriceAutoSyncStatus(selectedInventoryPropertyId, { silent: true });
      loadStopSellAutoSyncStatus(selectedInventoryPropertyId, { silent: true });
    };

    const intervalId = window.setInterval(
      refreshStatusesSilently,
      AUTO_SYNC_STATUS_POLL_MS
    );

    const handleWindowFocus = () => {
      refreshStatusesSilently();
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        refreshStatusesSilently();
      }
    };

    window.addEventListener("focus", handleWindowFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.clearInterval(intervalId);
      window.removeEventListener("focus", handleWindowFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [selectedInventoryPropertyId]);

  useEffect(() => {
    if (!inventoryData?.property?.id) {
      return;
    }

    const currentMapping = mappingsByProperty[String(inventoryData.property.id)] || null;

    setInventoryData((current) => {
      if (!current) {
        return current;
      }

      return {
        ...current,
        mapping: currentMapping,
      };
    });
  }, [inventoryData?.property?.id, mappingsByProperty]);

  useEffect(() => {
    if (!inventoryData) {
      setSelectedRoomCategoriesByRoomType({});
      setSelectedRoomRatesByRatePlan({});
      setAvailabilitySyncError("");
      setAvailabilitySyncMessage("");
      setAvailabilitySyncResult(null);
      setAvailabilityVerifyError("");
      setAvailabilityVerifyMessage("");
      setAvailabilityVerifyResult(null);
      setRestrictionsSyncError("");
      setRestrictionsSyncMessage("");
      setRestrictionsSyncResult(null);
      setFullSyncError("");
      setFullSyncMessage("");
      setFullSyncResult(null);
      setAutoSyncError("");
      setAutoSyncMessage("");
      setAutoSyncStatus(null);
      setStopSellAutoSyncError("");
      setStopSellAutoSyncMessage("");
      setStopSellAutoSyncStatus(null);
      return;
    }

    const nextRoomTypeSelections = {};
    const nextRatePlanSelections = {};

    (inventoryData.roomTypes || []).forEach((roomType) => {
      const currentMapping =
        inventoryRoomTypeMappingsByRoomType[String(roomType.id)] || null;
      nextRoomTypeSelections[String(roomType.id)] = currentMapping?.roomCategoryId
        ? String(currentMapping.roomCategoryId)
        : "";
    });

    (inventoryData.ratePlans || []).forEach((ratePlan) => {
      const currentMapping =
        inventoryRatePlanMappingsByRatePlan[String(ratePlan.id)] || null;
      nextRatePlanSelections[String(ratePlan.id)] = currentMapping?.roomRateId
        ? String(currentMapping.roomRateId)
        : "";
    });

    setSelectedRoomCategoriesByRoomType(nextRoomTypeSelections);
    setSelectedRoomRatesByRatePlan(nextRatePlanSelections);
  }, [
    inventoryData,
    inventoryRoomTypeMappingsByRoomType,
    inventoryRatePlanMappingsByRatePlan,
  ]);

  const handleSelectionChange = (propertyId, businessUnitId) => {
    setSelectedBusinessUnitsByProperty((current) => ({
      ...current,
      [String(propertyId)]: businessUnitId,
    }));
  };

  const handleRoomTypeSelectionChange = (roomTypeId, roomCategoryId) => {
    setSelectedRoomCategoriesByRoomType((current) => ({
      ...current,
      [String(roomTypeId)]: roomCategoryId,
    }));
  };

  const handleRatePlanSelectionChange = (ratePlanId, roomRateId) => {
    setSelectedRoomRatesByRatePlan((current) => ({
      ...current,
      [String(ratePlanId)]: roomRateId,
    }));
  };

  const handleSaveMapping = async (propertyId) => {
    const businessUnitId = selectedBusinessUnitsByProperty[String(propertyId)] || null;

    setSavingPropertyId(String(propertyId));
    setActionMessage("");
    setActionError("");

    try {
      await axios.put(`/api/integrations/channex/property-mappings/properties/${propertyId}`, {
        businessUnitId,
      });

      await loadMappings();

      if (String(selectedInventoryPropertyId || "") === String(propertyId)) {
        setInventoryData(null);
        setInventoryError("");
        setInventoryActionMessage("");
        setInventoryActionError("");
        setAvailabilitySyncError("");
        setAvailabilitySyncMessage("");
        setAvailabilitySyncResult(null);
        setAvailabilityVerifyError("");
        setAvailabilityVerifyMessage("");
        setAvailabilityVerifyResult(null);
        setRestrictionsSyncError("");
        setRestrictionsSyncMessage("");
        setRestrictionsSyncResult(null);
        setFullSyncError("");
        setFullSyncMessage("");
        setFullSyncResult(null);
        setAutoSyncError("");
        setAutoSyncMessage("");
        setAutoSyncStatus(null);
        setBookingsSyncError("");
        setBookingsSyncMessage("");
        setBookingsSyncStatus(null);
      }

      setActionMessage(
        businessUnitId
          ? "Channex property mapped to Business Unit."
          : "Channex property mapping cleared."
      );
    } catch (requestError) {
      console.error("Error saving Channex property mapping:", requestError);
      setActionError(
        requestError?.response?.data?.error || "Failed to save Channex property mapping."
      );
    } finally {
      setSavingPropertyId(null);
    }
  };

  const handleSaveRoomTypeMapping = async (roomTypeId) => {
    const propertyId = selectedInventoryPropertyId;
    const roomCategoryId = selectedRoomCategoriesByRoomType[String(roomTypeId)] || null;

    if (!propertyId || priceAutoSyncSendingPending) {
      return;
    }

    setSavingRoomTypeId(String(roomTypeId));
    setInventoryActionMessage("");
    setInventoryActionError("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/room-type-mappings/${roomTypeId}`,
        { roomCategoryId }
      );

      await reloadInventory(propertyId);

      const clearedCount = Number(response?.data?.clearedRatePlanMappingsCount || 0);
      const suffix =
        clearedCount > 0
          ? ` ${clearedCount} dependent rate plan mapping${clearedCount === 1 ? "" : "s"} cleared.`
          : "";

      setInventoryActionMessage(
        roomCategoryId ? `Room type mapping saved.${suffix}` : `Room type mapping cleared.${suffix}`
      );
    } catch (requestError) {
      console.error("Error saving Channex room type mapping:", requestError);
      setInventoryActionError(
        requestError?.response?.data?.error || "Failed to save Channex room type mapping."
      );
    } finally {
      setSavingRoomTypeId(null);
    }
  };

  const handleSaveRatePlanMapping = async (ratePlanId) => {
    const propertyId = selectedInventoryPropertyId;
    const roomRateId = selectedRoomRatesByRatePlan[String(ratePlanId)] || null;

    if (!propertyId) {
      return;
    }

    setSavingRatePlanId(String(ratePlanId));
    setInventoryActionMessage("");
    setInventoryActionError("");

    try {
      await axios.put(
        `/api/integrations/channex/properties/${propertyId}/rate-plan-mappings/${ratePlanId}`,
        { roomRateId }
      );

      await reloadInventory(propertyId);
      await Promise.all([
        loadLosAutoSyncStatus(propertyId),
        loadPriceAutoSyncStatus(propertyId),
        loadStopSellAutoSyncStatus(propertyId),
      ]);

      setInventoryActionMessage(
        roomRateId ? "Rate plan mapping saved." : "Rate plan mapping cleared."
      );
    } catch (requestError) {
      console.error("Error saving Channex rate plan mapping:", requestError);
      setInventoryActionError(
        requestError?.response?.data?.error || "Failed to save Channex rate plan mapping."
      );
    } finally {
      setSavingRatePlanId(null);
    }
  };

  const handleAvailabilitySync = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || !availabilityDateFrom || !availabilityDateTo) {
      return;
    }

    setAvailabilitySyncing(true);
    setAvailabilitySyncError("");
    setAvailabilitySyncMessage("");
    setAvailabilityVerifyError("");
    setAvailabilityVerifyMessage("");
    setAvailabilityVerifyResult(null);

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/availability/sync`,
        {
          dateFrom: availabilityDateFrom,
          dateTo: availabilityDateTo,
        }
      );

      setAvailabilitySyncResult(response.data);
      setAvailabilitySyncMessage(
        response?.data?.remote?.message
          ? `Availability sent to Channex staging. ${response.data.remote.message}.`
          : "Availability sent to Channex staging."
      );
    } catch (requestError) {
      console.error("Error syncing Channex availability:", requestError);
      setAvailabilitySyncResult(null);
      setAvailabilitySyncError(
        requestError?.response?.data?.error || "Failed to sync Channex availability."
      );
    } finally {
      setAvailabilitySyncing(false);
    }
  };

  const handleAvailabilityVerify = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || !availabilityDateFrom || !availabilityDateTo) {
      return;
    }

    setAvailabilityVerifying(true);
    setAvailabilityVerifyError("");
    setAvailabilityVerifyMessage("");

    try {
      const response = await axios.get(
        `/api/integrations/channex/properties/${propertyId}/availability/verify`,
        {
          params: {
            dateFrom: availabilityDateFrom,
            dateTo: availabilityDateTo,
          },
        }
      );

      setAvailabilityVerifyResult(response.data);

      const mismatchedRoomTypesCount = Number(response?.data?.mismatchedRoomTypesCount || 0);
      const mismatchesCount = Number(response?.data?.mismatchesCount || 0);
      const missingRemoteDatesCount = Number(response?.data?.missingRemoteDatesCount || 0);

      if (mismatchedRoomTypesCount === 0 && mismatchesCount === 0 && missingRemoteDatesCount === 0) {
        setAvailabilityVerifyMessage("Channex availability matches Pilcore for the selected range.");
      } else {
        setAvailabilityVerifyMessage(
          "Verification completed. Review mismatches and missing remote dates below."
        );
      }
    } catch (requestError) {
      console.error("Error verifying Channex availability:", requestError);
      setAvailabilityVerifyResult(null);
      setAvailabilityVerifyError(
        requestError?.response?.data?.error || "Failed to verify Channex availability."
      );
    } finally {
      setAvailabilityVerifying(false);
    }
  };

  const handleRestrictionsSync = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || !availabilityDateFrom || !availabilityDateTo) {
      return;
    }

    setRestrictionsSyncing(true);
    setRestrictionsSyncError("");
    setRestrictionsSyncMessage("");
    setRestrictionsSyncResult(null);
    setFullSyncError("");
    setFullSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/restrictions/sync`,
        {
          dateFrom: availabilityDateFrom,
          dateTo: availabilityDateTo,
        }
      );

      setRestrictionsSyncResult(response.data);
      setRestrictionsSyncMessage(
        response?.data?.remote?.message
          ? `Rates and restrictions sent to Channex staging. ${response.data.remote.message}.`
          : "Rates and restrictions sent to Channex staging."
      );
    } catch (requestError) {
      console.error("Error syncing Channex rates and restrictions:", requestError);
      setRestrictionsSyncResult(null);
      setRestrictionsSyncError(
        requestError?.response?.data?.error ||
          "Failed to sync Channex rates and restrictions."
      );
    } finally {
      setRestrictionsSyncing(false);
    }
  };

  const runFullSyncForRange = async ({ dateFrom, dateTo, mode = "manual" }) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || !dateFrom || !dateTo) {
      return;
    }

    setFullSyncing(true);
    setFullSyncError("");
    setFullSyncMessage("");
    setFullSyncResult(null);
    setRestrictionsSyncError("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/full-sync`,
        {
          dateFrom,
          dateTo,
        }
      );

      setFullSyncResult(response.data);
      setFullSyncMessage(
        mode === "certification"
          ? `Certification full sync sent to Channex staging for ${dateFrom} -> ${dateTo}.`
          : `Full sync sent to Channex staging for ${dateFrom} -> ${dateTo}.`
      );
      setAvailabilitySyncResult(response?.data?.availability || null);
      setRestrictionsSyncResult(response?.data?.restrictions || null);
    } catch (requestError) {
      console.error("Error running Channex full sync:", requestError);
      setFullSyncResult(null);
      setFullSyncError(
        requestError?.response?.data?.error || "Failed to run Channex full sync."
      );
    } finally {
      setFullSyncing(false);
    }
  };

  const handleFullSync = async () => {
    await runFullSyncForRange({
      dateFrom: availabilityDateFrom,
      dateTo: availabilityDateTo,
      mode: "manual",
    });
  };

  const handleCertificationFullSync = async () => {
    await runFullSyncForRange({
      dateFrom: buildRelativeDateInputValue(0),
      dateTo: buildRelativeDateInputValue(499),
      mode: "certification",
    });
  };

  const handleSetAutoSyncEnabled = async (enabled) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setAutoSyncUpdating(true);
    setAutoSyncError("");
    setAutoSyncMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/availability/auto-sync`,
        { enabled }
      );

      setAutoSyncStatus(response?.data?.autoSync || null);

      if (enabled) {
        const queuedRowsCount = Number(response?.data?.queuedRowsCount || 0);
        const seededRange = response?.data?.seededRange;
        const seededSuffix =
          seededRange?.dateFrom && seededRange?.dateTo
            ? ` Seeded range ${seededRange.dateFrom} -> ${seededRange.dateTo}.`
            : "";

        setAutoSyncMessage(
          `Auto availability sync enabled.${queuedRowsCount > 0 ? ` ${queuedRowsCount} row(s) queued.` : ""}${seededSuffix}`
        );
      } else {
        setAutoSyncMessage("Auto availability sync disabled.");
      }
    } catch (requestError) {
      console.error("Error updating Channex auto-sync status:", requestError);
      setAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to update Channex auto availability sync status."
      );
    } finally {
      setAutoSyncUpdating(false);
    }
  };

  const handleTogglePendingAriScope = (scopeKey) => {
    setSelectedPendingAriScopes((current) => ({
      ...current,
      [scopeKey]: !current?.[scopeKey],
    }));
  };

  const handleSendPendingAvailabilityChanges = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || autoSyncSendingPending) {
      return;
    }

    setAutoSyncSendingPending(true);
    setAutoSyncError("");
    setAutoSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/availability/auto-sync/send-pending`
      );

      setAutoSyncStatus(response?.data?.autoSync || null);
      setAutoSyncMessage(
        response?.data?.processed
          ? "Pending availability changes sent to Channex."
          : "No pending availability changes were queued."
      );
    } catch (requestError) {
      console.error("Error sending pending Channex availability changes:", requestError);
      setAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to send pending Channex availability changes."
      );
    } finally {
      setAutoSyncSendingPending(false);
    }
  };

  const handleSetStopSellAutoSyncEnabled = async (enabled) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setStopSellAutoSyncUpdating(true);
    setStopSellAutoSyncError("");
    setStopSellAutoSyncMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/stop-sell/auto-sync`,
        { enabled }
      );

      setStopSellAutoSyncStatus(response?.data?.autoSync || null);

      if (enabled) {
        const queuedRowsCount = Number(response?.data?.queuedRowsCount || 0);
        const seededRange = response?.data?.seededRange;
        const seededSuffix =
          seededRange?.dateFrom && seededRange?.dateTo
            ? ` Seeded range ${seededRange.dateFrom} -> ${seededRange.dateTo}.`
            : "";

        setStopSellAutoSyncMessage(
          `Auto stop-sell sync enabled.${queuedRowsCount > 0 ? ` ${queuedRowsCount} row(s) queued.` : ""}${seededSuffix}`
        );
      } else {
        setStopSellAutoSyncMessage("Auto stop-sell sync disabled.");
      }
    } catch (requestError) {
      console.error("Error updating Channex stop-sell auto-sync status:", requestError);
      setStopSellAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to update Channex auto stop-sell sync status."
      );
    } finally {
      setStopSellAutoSyncUpdating(false);
    }
  };

  const handleSendPendingStopSellChanges = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || stopSellAutoSyncSendingPending) {
      return;
    }

    setStopSellAutoSyncSendingPending(true);
    setStopSellAutoSyncError("");
    setStopSellAutoSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/stop-sell/auto-sync/send-pending`
      );

      setStopSellAutoSyncStatus(response?.data?.autoSync || null);
      setStopSellAutoSyncMessage(
        response?.data?.processed
          ? "Pending stop-sell changes sent to Channex."
          : "No pending stop-sell changes were queued."
      );
    } catch (requestError) {
      console.error("Error sending pending Channex stop-sell changes:", requestError);
      setStopSellAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to send pending Channex stop-sell changes."
      );
    } finally {
      setStopSellAutoSyncSendingPending(false);
    }
  };

  const handleReconcileStopSellErrors = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || stopSellAutoSyncReconcilingErrors) {
      return;
    }

    setStopSellAutoSyncReconcilingErrors(true);
    setStopSellAutoSyncError("");
    setStopSellAutoSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/stop-sell/auto-sync/reconcile-errors`
      );
      const result = response?.data || {};

      setStopSellAutoSyncStatus(result?.autoSync || null);
      setStopSellAutoSyncMessage(
        result?.processed
          ? `Checked ${Number(result.checkedRowsCount || 0)} error row(s). ${Number(
              result.alreadyResolvedRowsCount || 0
            )} already matched Channex. ${Number(result.reappliedRowsCount || 0)} reapplied. ${Number(
              result.failedRowsCount || 0
            )} still failing.`
          : "No stop-sell error rows to reconcile."
      );
    } catch (requestError) {
      console.error("Error reconciling Channex stop-sell errors:", requestError);
      setStopSellAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to reconcile Channex stop-sell errors."
      );
    } finally {
      setStopSellAutoSyncReconcilingErrors(false);
    }
  };

  const handleSetLosAutoSyncEnabled = async (enabled) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setLosAutoSyncUpdating(true);
    setLosAutoSyncError("");
    setLosAutoSyncMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/los/auto-sync`,
        { enabled }
      );

      setLosAutoSyncStatus(response?.data?.autoSync || null);

      if (enabled) {
        const queuedRowsCount = Number(response?.data?.queuedRowsCount || 0);
        const seededRange = response?.data?.seededRange;
        const seededSuffix =
          seededRange?.dateFrom && seededRange?.dateTo
            ? ` Seeded range ${seededRange.dateFrom} -> ${seededRange.dateTo}.`
            : "";

        setLosAutoSyncMessage(
          `Auto min/max stay sync enabled.${queuedRowsCount > 0 ? ` ${queuedRowsCount} row(s) queued.` : ""}${seededSuffix}`
        );
      } else {
        setLosAutoSyncMessage("Auto min/max stay sync disabled.");
      }
    } catch (requestError) {
      console.error("Error updating Channex min/max stay auto-sync status:", requestError);
      setLosAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to update Channex auto min/max stay sync status."
      );
    } finally {
      setLosAutoSyncUpdating(false);
    }
  };

  const handleSendPendingLosChanges = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || losAutoSyncSendingPending) {
      return;
    }

    setLosAutoSyncSendingPending(true);
    setLosAutoSyncError("");
    setLosAutoSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/los/auto-sync/send-pending`
      );

      setLosAutoSyncStatus(response?.data?.autoSync || null);
      setLosAutoSyncMessage(
        response?.data?.processed
          ? "Pending min/max stay changes sent to Channex."
          : "No pending min/max stay changes were queued."
      );
    } catch (requestError) {
      console.error("Error sending pending Channex min/max stay changes:", requestError);
      setLosAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to send pending Channex min/max stay changes."
      );
    } finally {
      setLosAutoSyncSendingPending(false);
    }
  };

  const handleSetPriceAutoSyncEnabled = async (enabled) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setPriceAutoSyncUpdating(true);
    setPriceAutoSyncError("");
    setPriceAutoSyncMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/prices/auto-sync`,
        { enabled }
      );

      setPriceAutoSyncStatus(response?.data?.autoSync || null);

      if (enabled) {
        const queuedRowsCount = Number(response?.data?.queuedRowsCount || 0);
        const seededRange = response?.data?.seededRange;
        const seededSuffix =
          seededRange?.dateFrom && seededRange?.dateTo
            ? ` Seeded range ${seededRange.dateFrom} -> ${seededRange.dateTo}.`
            : "";

        setPriceAutoSyncMessage(
          `Auto price sync enabled.${queuedRowsCount > 0 ? ` ${queuedRowsCount} row(s) queued.` : ""}${seededSuffix}`
        );
      } else {
        setPriceAutoSyncMessage("Auto price sync disabled.");
      }
    } catch (requestError) {
      console.error("Error updating Channex price auto-sync status:", requestError);
      setPriceAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to update Channex auto price sync status."
      );
    } finally {
      setPriceAutoSyncUpdating(false);
    }
  };

  const handleSendPendingPriceChanges = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || priceAutoSyncSendingPending) {
      return;
    }

    setPriceAutoSyncSendingPending(true);
    setPriceAutoSyncError("");
    setPriceAutoSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/prices/auto-sync/send-pending`
      );

      setPriceAutoSyncStatus(response?.data?.autoSync || null);
      setPriceAutoSyncMessage(
        response?.data?.processed
          ? "Pending price changes sent to Channex."
          : "No pending price changes were queued."
      );
    } catch (requestError) {
      console.error("Error sending pending Channex price changes:", requestError);
      setPriceAutoSyncError(
        requestError?.response?.data?.error ||
          "Failed to send pending Channex price changes."
      );
    } finally {
      setPriceAutoSyncSendingPending(false);
    }
  };

  const handleSendSelectedPendingAriChanges = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || pendingAriSending) {
      return;
    }

    const scopes = Object.entries(selectedPendingAriScopes || {})
      .filter(([, isSelected]) => Boolean(isSelected))
      .map(([scope]) => scope);

    setPendingAriSending(true);
    setPendingAriError("");
    setPendingAriMessage("");
    setPendingAriResult(null);

    if (!scopes.length) {
      setPendingAriError("Select at least one ARI scope before sending.");
      setPendingAriSending(false);
      return;
    }

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/ari/send-pending`,
        {
          scopes,
        }
      );

      const result = response?.data || null;

      setPendingAriResult(result);
      setAutoSyncStatus(result?.autoSync?.availability || null);
      setStopSellAutoSyncStatus(result?.autoSync?.stopSell || null);
      setLosAutoSyncStatus(result?.autoSync?.los || null);
      setPriceAutoSyncStatus(result?.autoSync?.price || null);

      const availabilityProcessed = Boolean(result?.availability?.processed);
      const restrictionsProcessed = Boolean(result?.restrictions?.processed);

      if (!availabilityProcessed && !restrictionsProcessed) {
        setPendingAriMessage("No pending changes were queued for the selected ARI scopes.");
      } else if (availabilityProcessed && restrictionsProcessed) {
        setPendingAriMessage("Selected pending ARI changes sent to Channex.");
      } else if (availabilityProcessed) {
        setPendingAriMessage(
          "Selected pending availability changes sent to Channex. No pending selected restrictions changes were queued."
        );
      } else {
        setPendingAriMessage(
          "Selected pending restrictions changes sent to Channex. No pending selected availability changes were queued."
        );
      }

      if (availabilityProcessed || restrictionsProcessed || result?.summary?.hasErrors) {
        const recentBatch = {
          id: `${propertyId}-${Date.now()}`,
          propertyId: String(propertyId),
          createdAt: new Date().toISOString(),
          status: result?.summary?.hasErrors
            ? "completed_with_errors"
            : availabilityProcessed || restrictionsProcessed
              ? "completed"
              : "idle",
          selectedScopes: Array.isArray(result?.summary?.selectedScopes)
            ? result.summary.selectedScopes
            : scopes,
          availabilityProcessed,
          restrictionsProcessed,
          availabilityPayloadItemsCount: Number(result?.availability?.payloadItemsCount || 0),
          restrictionsPayloadItemsCount: Number(result?.restrictions?.payloadItemsCount || 0),
          remoteTaskCount: Number(result?.summary?.remoteTaskCount || 0),
          availabilityTasks: result?.availability?.remote?.tasks || [],
          restrictionsTasks: result?.restrictions?.remote?.tasks || [],
          errors: Array.isArray(result?.errors) ? result.errors : [],
        };

        setPendingAriRecentBatches((current) => [recentBatch, ...current].slice(0, 12));
      }

      if (result?.summary?.hasErrors) {
        setPendingAriError(
          Array.isArray(result?.errors) && result.errors.length
            ? result.errors.map((item) => item?.message).filter(Boolean).join(" ")
            : "Some selected ARI changes could not be sent."
        );
      }
    } catch (requestError) {
      console.error("Error sending selected pending Channex ARI changes:", requestError);
      setPendingAriError(
        requestError?.response?.data?.error ||
          "Failed to send selected pending Channex ARI changes."
      );
    } finally {
      setPendingAriSending(false);
    }
  };

  const handleSetBookingsAutoSyncEnabled = async (enabled) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setBookingsSyncUpdating(true);
    setBookingsSyncError("");
    setBookingsSyncMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/bookings/auto-sync`,
        { enabled }
      );

      setBookingsSyncStatus(response.data || null);

      const backupPullIntervalSeconds = Number(
        response?.data?.setup?.backupPullIntervalSeconds ||
          response?.data?.autoSync?.backupPullIntervalSeconds ||
          response?.data?.summary?.backupPullIntervalSeconds ||
          0
      );
      const webhookTestOk = Boolean(response?.data?.setup?.webhookTest?.ok);
      const webhookTestStatusCode = Number(response?.data?.setup?.webhookTest?.statusCode || 0);
      const backupPullLabel =
        backupPullIntervalSeconds > 0 && backupPullIntervalSeconds % 60 === 0
          ? `${backupPullIntervalSeconds / 60} minute${
              backupPullIntervalSeconds / 60 === 1 ? "" : "s"
            }`
          : `${backupPullIntervalSeconds} second${
              backupPullIntervalSeconds === 1 ? "" : "s"
            }`;

      setBookingsSyncMessage(
        enabled
          ? `Real-time booking sync enabled.${
              webhookTestStatusCode > 0
                ? webhookTestOk
                  ? ` Webhook test returned ${webhookTestStatusCode}.`
                  : ` Webhook registered, but the test returned ${webhookTestStatusCode}.`
                : ""
            }${
              backupPullIntervalSeconds > 0
                ? ` Backup pull stays active every ${backupPullLabel}.`
                : ""
            }`
          : "Real-time booking sync disabled. Manual sync remains available."
      );
    } catch (requestError) {
      console.error("Error updating Channex booking auto-sync status:", requestError);
      setBookingsSyncError(
        requestError?.response?.data?.error ||
          "Failed to update Channex auto booking sync status."
      );
    } finally {
      setBookingsSyncUpdating(false);
    }
  };

  const handleSaveServiceMapping = async (mappingId, nextExtraId) => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId || !mappingId) {
      return;
    }

    setServiceMappingsSavingId(String(mappingId));
    setServiceMappingsError("");
    setServiceMappingsMessage("");

    try {
      const response = await axios.put(
        `/api/integrations/channex/properties/${propertyId}/services/mappings/${mappingId}`,
        {
          extraId: nextExtraId || null,
        }
      );

      setServiceMappingsStatus(response.data || null);
      setServiceMappingsMessage(
        nextExtraId
          ? "Service mapping saved. Use Reapply Mapped Services if you want existing tracked bookings to backfill this extra now."
          : "Service mapping cleared."
      );
    } catch (requestError) {
      console.error("Error saving Channex service mapping:", requestError);
      setServiceMappingsError(
        requestError?.response?.data?.error || "Failed to save Channex service mapping."
      );
    } finally {
      setServiceMappingsSavingId(null);
    }
  };

  const handleCreateServiceMapping = async () => {
    const propertyId = selectedInventoryPropertyId;
    const normalizedServiceName = String(manualServiceName || "").trim();

    if (!propertyId || !normalizedServiceName) {
      return;
    }

    setServiceMappingsCreating(true);
    setServiceMappingsError("");
    setServiceMappingsMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/services/mappings`,
        {
          serviceName: normalizedServiceName,
          scope: manualServiceScope,
          extraId: manualServiceExtraId ? Number(manualServiceExtraId) : null,
        }
      );

      setServiceMappingsStatus(response.data || null);
      setManualServiceName("");
      setServiceMappingsMessage(
        manualServiceExtraId
          ? "Manual service mapping saved. You can now reapply extras from tracked bookings immediately."
          : "Manual Channex service created. Link it to a Pilcore extra when you are ready."
      );
    } catch (requestError) {
      console.error("Error creating Channex service mapping:", requestError);
      setServiceMappingsError(
        requestError?.response?.data?.error || "Failed to create Channex service mapping."
      );
    } finally {
      setServiceMappingsCreating(false);
    }
  };

  const handleReapplyPropertyServices = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setServiceMappingsReapplying(true);
    setServiceMappingsError("");
    setServiceMappingsMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/services/reapply`
      );
      const counters = response?.data?.counters || {};
      const warningsCount = Array.isArray(response?.data?.warnings)
        ? response.data.warnings.length
        : 0;

      setServiceMappingsStatus(response?.data?.serviceMappings || null);
      setServiceMappingsMessage(
        `Reapply completed. Processed ${Number(counters.processedBookingsCount || 0)} booking${
          Number(counters.processedBookingsCount || 0) === 1 ? "" : "s"
        }, refreshed ${Number(counters.updatedBookingsCount || 0)}, cleared ${
          Number(counters.clearedBookingsCount || 0)
        }, created ${Number(counters.createdExtrasCount || 0)} extra row${
          Number(counters.createdExtrasCount || 0) === 1 ? "" : "s"
        }.${
          warningsCount > 0
            ? ` ${warningsCount} booking${warningsCount === 1 ? "" : "s"} had a warning while reapplying.`
            : ""
        }`
      );
    } catch (requestError) {
      console.error("Error reapplying Channex services:", requestError);
      setServiceMappingsError(
        requestError?.response?.data?.error ||
          "Failed to reapply Channex services from tracked bookings."
      );
    } finally {
      setServiceMappingsReapplying(false);
    }
  };

  const handleRefreshBookingsAndServices = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    await Promise.all([loadBookingsSyncStatus(propertyId), loadServiceMappings(propertyId)]);
  };

  const handleRunBookingsSync = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setBookingsSyncRunning(true);
    setBookingsSyncError("");
    setBookingsSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/bookings/sync`
      );

      setBookingsSyncStatus(response.data || null);

      const counters = response?.data?.counters || {};
      const fetchedCount = Number(counters.fetchedCount || 0);
      const processedCount = Number(counters.processedCount || 0);
      const importedCount = Number(counters.importedCount || 0);
      const cancelledCount = Number(counters.cancelledCount || 0);
      const ackedCount = Number(counters.ackedCount || 0);
      const failedCount = Number(counters.failedCount || 0);

      if (fetchedCount === 0) {
        setBookingsSyncMessage(
          "No unacknowledged Channex booking revisions were found for the selected property."
        );
      } else if (failedCount > 0) {
        setBookingsSyncMessage(
          `Booking sync completed with errors. Processed ${processedCount}, imported ${importedCount}, cancelled ${cancelledCount}, acked ${ackedCount}, failed ${failedCount}.`
        );
      } else {
        setBookingsSyncMessage(
          `Booking sync completed. Processed ${processedCount}, imported ${importedCount}, cancelled ${cancelledCount}, acked ${ackedCount}.`
        );
      }

      await loadServiceMappings(propertyId);
    } catch (requestError) {
      console.error("Error syncing Channex bookings:", requestError);
      setBookingsSyncError(
        requestError?.response?.data?.error || "Failed to sync Channex bookings."
      );
    } finally {
      setBookingsSyncRunning(false);
    }
  };

  const handleRetryBookingRevision = async (revision) => {
    const propertyId = selectedInventoryPropertyId;
    const revisionId = String(revision?.revisionId || "").trim();
    const actionLabel = getBookingRevisionActionLabel(revision);

    if (!propertyId || !revisionId) {
      return;
    }

    setBookingsRetryingRevisionId(revisionId);
    setBookingsSyncError("");
    setBookingsSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/bookings/revisions/${revisionId}/retry`
      );

      setBookingsSyncStatus(response.data || null);

      const retriedRevision = response?.data?.retriedRevision || null;
      const retryStillFailing =
        String(retriedRevision?.importStatus || "").toLowerCase() === "error" ||
        String(retriedRevision?.ackStatus || "").toLowerCase() === "error";
      const retryStillPending =
        String(retriedRevision?.ackStatus || "").toLowerCase() === "pending" ||
        ["pending", "processing"].includes(
          String(retriedRevision?.importStatus || "").toLowerCase()
        );

      if (retryStillFailing) {
        setBookingsSyncMessage(
          `${actionLabel} completed for revision ${revisionId}, but it is still failing. Review the updated reason below.`
        );
      } else if (retryStillPending) {
        setBookingsSyncMessage(
          `${actionLabel} completed for revision ${revisionId}, but it is still pending. Review the updated status below.`
        );
      } else {
        setBookingsSyncMessage(`Revision ${revisionId} processed successfully.`);
      }

      await loadServiceMappings(propertyId);
    } catch (requestError) {
      console.error("Error retrying Channex booking revision:", requestError);
      setBookingsSyncError(
        requestError?.response?.data?.error || "Failed to retry Channex booking revision."
      );
    } finally {
      setBookingsRetryingRevisionId(null);
    }
  };

  const handleRetryAllFailedBookings = async () => {
    const propertyId = selectedInventoryPropertyId;

    if (!propertyId) {
      return;
    }

    setBookingsRetryingAll(true);
    setBookingsSyncError("");
    setBookingsSyncMessage("");

    try {
      const response = await axios.post(
        `/api/integrations/channex/properties/${propertyId}/bookings/retry-failed`
      );

      setBookingsSyncStatus(response.data || null);
      const retriedCount = Number(response?.data?.retriedCount || 0);
      const failedCount = Number(response?.data?.counters?.failedCount || 0);

      if (failedCount > 0) {
        setBookingsSyncMessage(
          `Bulk reprocess completed for ${retriedCount} revision${retriedCount === 1 ? "" : "s"}, but ${failedCount} still need attention.`
        );
      } else {
        setBookingsSyncMessage(
          `Bulk reprocess completed. ${retriedCount} revision${retriedCount === 1 ? "" : "s"} reprocessed.`
        );
      }

      await loadServiceMappings(propertyId);
    } catch (requestError) {
      console.error("Error reprocessing Channex booking revisions in bulk:", requestError);
      setBookingsSyncError(
        requestError?.response?.data?.error ||
          "Failed to reprocess selected Channex booking revisions."
      );
    } finally {
      setBookingsRetryingAll(false);
    }
  };

  const toggleBookingRevisionHistory = (revisionId) => {
    const revisionKey = String(revisionId || "").trim();

    if (!revisionKey) {
      return;
    }

    setExpandedBookingErrorHistoryByRevision((current) => ({
      ...current,
      [revisionKey]: !current[revisionKey],
    }));
  };

  const handleExportBookingErrors = () => {
    if (!exportableBookingErrorRevisions.length) {
      return;
    }

    const filename = `channex-booking-errors-${selectedInventoryPropertyId || "property"}-${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}.csv`;

    const rows = exportableBookingErrorRevisions.map((revision) => [
      revision.revisionId || "",
      revision.bookingId || "",
      revision.otaReservationCode || "",
      Array.isArray(revision.localReservationLocators)
        ? revision.localReservationLocators.join(" | ")
        : "",
      revision.importStatus || "",
      revision.ackStatus || "",
      getBookingRevisionErrorStageLabel(revision),
      revision.lastError || "",
      revision.lastAttemptAt || "",
      buildBookingRevisionHistorySummary(revision),
    ]);

    downloadCsvFile(
      filename,
      [
        "Revision ID",
        "Booking ID",
        "OTA Locator",
        "Pilcore Locator(s)",
        "Import Status",
        "Ack Status",
        "Error Stage",
        "Last Error",
        "Last Attempt At",
        "Error History",
      ],
      rows
    );

    setBookingsSyncMessage(
      `Exported ${exportableBookingErrorRevisions.length} booking error revision${
        exportableBookingErrorRevisions.length === 1 ? "" : "s"
      } to CSV.`
    );
    setBookingsSyncError("");
  };

  const selectedInventoryMapping =
    mappedProperties.find(
      (mapping) => String(mapping.propertyId) === String(selectedInventoryPropertyId || "")
    ) || null;

  const pendingAriRecentBatchesForProperty = useMemo(
    () =>
      pendingAriRecentBatches.filter(
        (batch) => String(batch?.propertyId || "") === String(selectedInventoryPropertyId || "")
      ),
    [pendingAriRecentBatches, selectedInventoryPropertyId]
  );

  return (
    <>
      <style>{channexCardCss}</style>

      <div className={`chx-card ${embedded ? "chx-card--embedded" : ""}`}>
        <div className="chx-header">
          <div>
            <div className="chx-kicker">Channel Manager</div>
            <h2 className="chx-title">Channex</h2>
            <div className="chx-subtitle">
              Follow the Channex flow in order: map the property, reload the inventory,
              connect room types and rate plans, then push availability.
            </div>
          </div>

          <div className="chx-badge">Staging</div>
        </div>

        <div className="chx-body">
          <div className="chx-toolbar">
            <button
              type="button"
              className="chx-btn"
              onClick={loadProperties}
              disabled={loadingProperties}
            >
              {loadingProperties
                ? "Loading..."
                : hasLoadedProperties
                  ? "Reload Properties"
                  : "Load Properties"}
            </button>

            <div className="chx-chipRow">
              <span className="chx-chip">
                {sortedProperties.length} {sortedProperties.length === 1 ? "property" : "properties"}
              </span>
              <span className="chx-chip chx-chip--success">
                {mappedCount} mapped
              </span>
              <span className="chx-chip chx-chip--muted">
                {unmappedCount} unmapped
              </span>
            </div>
          </div>

          <div className="chx-note">
            This tab keeps the Channex guide sequence intact: property to Business Unit
            first, then inventory reload, then room type and rate plan mapping, then
            availability sync.
          </div>

          {actionError ? (
            <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
              {actionError}
            </div>
          ) : null}

          {actionMessage ? (
            <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
              {actionMessage}
            </div>
          ) : null}

          <div className="chx-stack">
            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 1</div>
                <h3 className="chx-sectionTitle">Property to Business Unit Mapping</h3>
                <div className="chx-sectionSubtitle">
                  Review each Channex property and assign the corresponding Business Unit.
                </div>
              </div>

              <div className="chx-sectionBody">
                {propertiesError ? (
                  <div className="chx-feedback chx-feedback--error">{propertiesError}</div>
                ) : loadingProperties && sortedProperties.length === 0 ? (
                  <div className="chx-feedback">Loading Channex properties...</div>
                ) : sortedProperties.length === 0 ? (
                  <div className="chx-feedback">
                    Use Load Properties to fetch the Channex staging inventory.
                  </div>
                ) : (
                  <>
                    {mappingsError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {mappingsError}
                      </div>
                    ) : null}

                    <div className="chx-table">
                      <div className="chx-tableHeader">
                        <div className="chx-tableHeadCell">Property</div>
                        <div className="chx-tableHeadCell">Details</div>
                        <div className="chx-tableHeadCell">Business Unit</div>
                        <div className="chx-tableHeadCell">Action</div>
                      </div>

                      {sortedProperties.map((property) => {
                        const currentMapping = mappingsByProperty[String(property.id)];
                        const selectedBusinessUnitId =
                          selectedBusinessUnitsByProperty[String(property.id)] || "";
                        const currentBusinessUnitId = currentMapping?.businessUnitId
                          ? String(currentMapping.businessUnitId)
                          : "";
                        const hasUnsavedChange =
                          String(selectedBusinessUnitId) !== String(currentBusinessUnitId);
                        const canSave = hasUnsavedChange && !loadingMappings;
                        const detailLine = buildPropertyDetailLine(property);

                        return (
                          <div className="chx-tableRow" key={property.id || property.title}>
                            <div className="chx-propertyCell">
                              <div className="chx-propertyLine">
                                <div className="chx-propertyName">{property.title}</div>
                                <span
                                  className={`chx-chip ${
                                    currentMapping ? "chx-chip--success" : "chx-chip--muted"
                                  }`}
                                >
                                  {currentMapping ? "Mapped" : "Unmapped"}
                                </span>
                              </div>
                              <div className="chx-propertyId">ID: {property.id || "N/A"}</div>
                            </div>

                            <div className="chx-metaText">
                              {detailLine || "No extra details available."}
                            </div>

                            <div>
                              <div className="chx-currentMap">
                                Current: {currentMapping?.businessUnit?.name || "No Business Unit assigned"}
                              </div>
                              <label className="chx-fieldLabel" htmlFor={`chx-bu-${property.id}`}>
                                Assign Business Unit
                              </label>
                              <select
                                id={`chx-bu-${property.id}`}
                                className="form-select chx-select"
                                value={selectedBusinessUnitId}
                                onChange={(event) =>
                                  handleSelectionChange(property.id, event.target.value)
                                }
                                disabled={loadingMappings || sortedBusinessUnits.length === 0}
                              >
                                <option value="">-- Unmapped --</option>
                                {sortedBusinessUnits.map((businessUnit) => (
                                  <option key={businessUnit.id} value={businessUnit.id}>
                                    {businessUnit.name}
                                  </option>
                                ))}
                              </select>
                              <div className="chx-inlineNote">
                                {hasUnsavedChange ? "Unsaved change." : "Already in sync."}
                              </div>
                            </div>

                            <div className="chx-cellAction">
                              <button
                                type="button"
                                className={`chx-btn ${hasUnsavedChange ? "" : "chx-btn--secondary"}`}
                                onClick={() => handleSaveMapping(property.id)}
                                disabled={!canSave || savingPropertyId === String(property.id)}
                              >
                                {savingPropertyId === String(property.id) ? "Saving..." : "Save"}
                              </button>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 2</div>
                <h3 className="chx-sectionTitle">Reload Inventory</h3>
                <div className="chx-sectionSubtitle">
                  Load Channex room types and rate plans together with the Pilcore room
                  categories and room rates for the mapped Business Unit.
                </div>
              </div>

              <div className="chx-sectionBody">
                {mappedProperties.length === 0 ? (
                  <div className="chx-feedback">
                    Map at least one Channex property first. Then you can reload its room
                    types, rate plans, room categories and room rates here.
                  </div>
                ) : (
                  <>
                    <div className="chx-inventoryToolbar">
                      <div>
                        <label className="chx-fieldLabel" htmlFor="chx-inventory-property">
                          Mapped Property
                        </label>
                        <select
                          id="chx-inventory-property"
                          className="form-select chx-select"
                          value={selectedInventoryPropertyId}
                          onChange={(event) => {
                            setSelectedInventoryPropertyId(event.target.value);
                            setInventoryData(null);
                            setInventoryError("");
                            setInventoryActionMessage("");
                            setInventoryActionError("");
                            setAvailabilitySyncError("");
                            setAvailabilitySyncMessage("");
                            setAvailabilitySyncResult(null);
                            setAvailabilityVerifyError("");
                            setAvailabilityVerifyMessage("");
                            setAvailabilityVerifyResult(null);
                            setAutoSyncError("");
                            setAutoSyncMessage("");
                            setAutoSyncStatus(null);
                          }}
                        >
                          {mappedProperties.map((mapping) => (
                            <option key={mapping.propertyId} value={mapping.propertyId}>
                              {buildMappedPropertyLabel(mapping)}
                            </option>
                          ))}
                        </select>
                      </div>

                      <button
                        type="button"
                        className="chx-btn"
                        onClick={() => reloadInventory()}
                        disabled={!selectedInventoryPropertyId || inventoryLoading}
                      >
                        {inventoryLoading ? "Reloading..." : "Reload Inventory"}
                      </button>
                    </div>

                    <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                      <span className="chx-chip">
                        Selected: {selectedInventoryMapping?.propertyTitle || "No property selected"}
                      </span>
                      <span className="chx-chip">
                        BU: {selectedInventoryMapping?.businessUnit?.name || "Unmapped"}
                      </span>
                      {inventoryData ? (
                        <>
                          <span className="chx-chip chx-chip--success">
                            {inventoryData.roomTypesCount} room types
                          </span>
                          <span className="chx-chip chx-chip--success">
                            {inventoryData.ratePlansCount} rate plans
                          </span>
                          <span className="chx-chip chx-chip--success">
                            {inventoryData.roomCategoriesCount} room categories
                          </span>
                          <span className="chx-chip chx-chip--success">
                            {inventoryData.roomRatesCount} room rates
                          </span>
                        </>
                      ) : null}
                    </div>

                    {inventoryError ? (
                      <div className="chx-feedback chx-feedback--error">{inventoryError}</div>
                    ) : inventoryLoading && !inventoryData ? (
                      <div className="chx-feedback">
                        Loading room types, rate plans, room categories and room rates...
                      </div>
                    ) : inventoryData ? (
                      <div className="chx-inventoryGrid">
                        <div className="chx-miniPanel">
                          <div className="chx-miniHeader">
                            <div className="chx-miniTitle">Room Types</div>
                            <span className="chx-chip">{inventoryData.roomTypesCount}</span>
                          </div>

                          {inventoryData.roomTypes.length === 0 ? (
                            <div className="chx-miniEmpty">No room types found for this property.</div>
                          ) : (
                            <div className="chx-miniList">
                              {inventoryData.roomTypes.map((roomType) => (
                                <div className="chx-miniRow" key={roomType.id || roomType.title}>
                                  <div className="chx-miniRowTitle">{roomType.title}</div>
                                  <div className="chx-miniRowMeta">
                                    {buildRoomTypeMeta(roomType) || "No extra details available."}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>

                        <div className="chx-miniPanel">
                          <div className="chx-miniHeader">
                            <div className="chx-miniTitle">Rate Plans</div>
                            <span className="chx-chip">{inventoryData.ratePlansCount}</span>
                          </div>

                          {inventoryData.ratePlans.length === 0 ? (
                            <div className="chx-miniEmpty">No rate plans found for this property.</div>
                          ) : (
                            <div className="chx-miniList">
                              {inventoryData.ratePlans.map((ratePlan) => (
                                <div className="chx-miniRow" key={ratePlan.id || ratePlan.title}>
                                  <div className="chx-miniRowTitle">{ratePlan.title}</div>
                                  <div className="chx-miniRowMeta">
                                    {buildRatePlanMeta(ratePlan) || "No extra details available."}
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div className="chx-feedback">
                        Pick a mapped property and press Reload Inventory to fetch its Channex
                        inventory and the corresponding Pilcore categories and rates.
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 3</div>
                <h3 className="chx-sectionTitle">Inventory Mapping</h3>
                <div className="chx-sectionSubtitle">
                  Map Channex room types to Pilcore room categories first. Then map rate
                  plans to room rates from the matching category.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!inventoryData ? (
                  <div className="chx-feedback">
                    Reload inventory first. The room type and rate plan mapping tables will
                    appear here once the property inventory is loaded.
                  </div>
                ) : (
                  <>
                    {inventoryActionError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {inventoryActionError}
                      </div>
                    ) : null}

                    {inventoryActionMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {inventoryActionMessage}
                      </div>
                    ) : null}

                    <div className="chx-note">
                      Rate plans stay locked until their Channex room type has a room
                      category mapping. If you change a room type mapping, dependent rate
                      plan mappings are cleared to keep the chain consistent.
                    </div>

                    <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                      <span className="chx-chip chx-chip--success">
                        {inventoryData.roomTypeMappingsCount} room types mapped
                      </span>
                      <span className="chx-chip chx-chip--success">
                        {inventoryData.ratePlanMappingsCount} rate plans mapped
                      </span>
                    </div>

                    <div className="chx-mappingGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Room Type -> Room Category</div>
                          <span className="chx-chip">{inventoryData.roomTypesCount}</span>
                        </div>

                        {inventoryData.roomTypes.length === 0 ? (
                          <div className="chx-miniEmpty">No room types available to map.</div>
                        ) : inventoryData.roomCategories.length === 0 ? (
                          <div className="chx-miniEmpty">
                            No room categories found in Pilcore for this Business Unit.
                          </div>
                        ) : (
                          <div className="chx-mapTable">
                            <div className="chx-mapHeader">
                              <div className="chx-tableHeadCell">Channex Room Type</div>
                              <div className="chx-tableHeadCell">Current Category</div>
                              <div className="chx-tableHeadCell">Pilcore Category</div>
                              <div className="chx-tableHeadCell">Action</div>
                            </div>

                            {inventoryData.roomTypes.map((roomType) => {
                              const currentMapping =
                                inventoryRoomTypeMappingsByRoomType[String(roomType.id)] || null;
                              const currentRoomCategory =
                                inventoryData.roomCategories.find(
                                  (roomCategory) =>
                                    String(roomCategory.id) ===
                                    String(currentMapping?.roomCategoryId || "")
                                ) || null;
                              const selectedRoomCategoryId =
                                selectedRoomCategoriesByRoomType[String(roomType.id)] || "";
                              const currentRoomCategoryId = currentMapping?.roomCategoryId
                                ? String(currentMapping.roomCategoryId)
                                : "";
                              const hasUnsavedChange =
                                String(selectedRoomCategoryId) !== String(currentRoomCategoryId);
                              const canSave = hasUnsavedChange && !inventoryLoading;

                              return (
                                <div className="chx-mapRow" key={roomType.id || roomType.title}>
                                  <div>
                                    <div className="chx-mapTitle">{roomType.title}</div>
                                    <div className="chx-mapMeta">
                                      {buildRoomTypeMeta(roomType) || "No extra details available."}
                                    </div>
                                  </div>

                                  <div className="chx-mapCurrent">
                                    <div className="chx-mapCurrentName">
                                      {currentRoomCategory?.name || "Unmapped"}
                                    </div>
                                    <div className="chx-mapCurrentMeta">
                                      {currentRoomCategory
                                        ? buildRoomCategoryMeta(currentRoomCategory) ||
                                          "Mapped to Pilcore room category."
                                        : "No room category selected yet."}
                                    </div>
                                  </div>

                                  <div>
                                    <label
                                      className="chx-fieldLabel"
                                      htmlFor={`chx-room-type-map-${roomType.id}`}
                                    >
                                      Pilcore Room Category
                                    </label>
                                    <select
                                      id={`chx-room-type-map-${roomType.id}`}
                                      className="form-select chx-select"
                                      value={selectedRoomCategoryId}
                                      onChange={(event) =>
                                        handleRoomTypeSelectionChange(
                                          roomType.id,
                                          event.target.value
                                        )
                                      }
                                      disabled={inventoryLoading}
                                    >
                                      <option value="">-- Unmapped --</option>
                                      {inventoryData.roomCategories.map((roomCategory) => (
                                        <option key={roomCategory.id} value={roomCategory.id}>
                                          {roomCategory.name}
                                        </option>
                                      ))}
                                    </select>
                                    <div className="chx-inlineNote">
                                      {hasUnsavedChange ? "Unsaved change." : "Already in sync."}
                                    </div>
                                  </div>

                                  <div className="chx-mapAction">
                                    <button
                                      type="button"
                                      className={`chx-btn ${hasUnsavedChange ? "" : "chx-btn--secondary"}`}
                                      onClick={() => handleSaveRoomTypeMapping(roomType.id)}
                                      disabled={!canSave || savingRoomTypeId === String(roomType.id)}
                                    >
                                      {savingRoomTypeId === String(roomType.id) ? "Saving..." : "Save"}
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Rate Plan -> Room Rate</div>
                          <span className="chx-chip">{inventoryData.ratePlansCount}</span>
                        </div>

                        {inventoryData.ratePlans.length === 0 ? (
                          <div className="chx-miniEmpty">No rate plans available to map.</div>
                        ) : (
                          <div className="chx-mapTable">
                            <div className="chx-mapHeader">
                              <div className="chx-tableHeadCell">Channex Rate Plan</div>
                              <div className="chx-tableHeadCell">Current Room Rate</div>
                              <div className="chx-tableHeadCell">Pilcore Room Rate</div>
                              <div className="chx-tableHeadCell">Action</div>
                            </div>

                            {inventoryData.ratePlans.map((ratePlan) => {
                              const currentMapping =
                                inventoryRatePlanMappingsByRatePlan[String(ratePlan.id)] || null;
                              const currentRoomRate =
                                inventoryData.roomRates.find(
                                  (roomRate) =>
                                    String(roomRate.id) === String(currentMapping?.roomRateId || "")
                                ) || null;
                              const roomTypeMapping =
                                inventoryRoomTypeMappingsByRoomType[String(ratePlan.roomTypeId)] || null;
                              const availableRoomRates = roomTypeMapping?.roomCategoryId
                                ? inventoryData.roomRates.filter(
                                    (roomRate) =>
                                      String(roomRate.roomCategoryId) ===
                                      String(roomTypeMapping.roomCategoryId)
                                  )
                                : [];
                              const selectedRoomRateId =
                                selectedRoomRatesByRatePlan[String(ratePlan.id)] || "";
                              const currentRoomRateId = currentMapping?.roomRateId
                                ? String(currentMapping.roomRateId)
                                : "";
                              const hasUnsavedChange =
                                String(selectedRoomRateId) !== String(currentRoomRateId);
                              const canSave =
                                hasUnsavedChange &&
                                !inventoryLoading &&
                                (!!roomTypeMapping?.roomCategoryId || !!currentRoomRateId);
                              const inlineNote = !roomTypeMapping?.roomCategoryId
                                ? "Map the room type first."
                                : availableRoomRates.length === 0
                                  ? "No room rates found for the mapped room category."
                                  : hasUnsavedChange
                                    ? "Unsaved change."
                                    : "Already in sync.";

                              return (
                                <div className="chx-mapRow" key={ratePlan.id || ratePlan.title}>
                                  <div>
                                    <div className="chx-mapTitle">{ratePlan.title}</div>
                                    <div className="chx-mapMeta">
                                      {buildRatePlanMeta(ratePlan) || "No extra details available."}
                                    </div>
                                  </div>

                                  <div className="chx-mapCurrent">
                                    <div className="chx-mapCurrentName">
                                      {currentRoomRate?.name || "Unmapped"}
                                    </div>
                                    <div className="chx-mapCurrentMeta">
                                      {currentRoomRate
                                        ? buildRoomRateMeta(currentRoomRate) ||
                                          "Mapped to Pilcore room rate."
                                        : roomTypeMapping?.roomCategory?.name
                                          ? `Expected category: ${roomTypeMapping.roomCategory.name}`
                                          : "Waiting for a room type mapping."}
                                    </div>
                                  </div>

                                  <div>
                                    <label
                                      className="chx-fieldLabel"
                                      htmlFor={`chx-rate-plan-map-${ratePlan.id}`}
                                    >
                                      Pilcore Room Rate
                                    </label>
                                    <select
                                      id={`chx-rate-plan-map-${ratePlan.id}`}
                                      className="form-select chx-select"
                                      value={selectedRoomRateId}
                                      onChange={(event) =>
                                        handleRatePlanSelectionChange(
                                          ratePlan.id,
                                          event.target.value
                                        )
                                      }
                                      disabled={!roomTypeMapping?.roomCategoryId || inventoryLoading}
                                    >
                                      <option value="">-- Unmapped --</option>
                                      {availableRoomRates.map((roomRate) => (
                                        <option key={roomRate.id} value={roomRate.id}>
                                          {buildRoomRateOptionLabel(roomRate)}
                                        </option>
                                      ))}
                                    </select>
                                    <div className="chx-inlineNote">{inlineNote}</div>
                                  </div>

                                  <div className="chx-mapAction">
                                    <button
                                      type="button"
                                      className={`chx-btn ${hasUnsavedChange ? "" : "chx-btn--secondary"}`}
                                      onClick={() => handleSaveRatePlanMapping(ratePlan.id)}
                                      disabled={!canSave || savingRatePlanId === String(ratePlan.id)}
                                    >
                                      {savingRatePlanId === String(ratePlan.id) ? "Saving..." : "Save"}
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 4</div>
                <h3 className="chx-sectionTitle">Send Availability</h3>
                <div className="chx-sectionSubtitle">
                  Push Pilcore availability to Channex staging, then verify it back from the
                  Channex API for the same date range.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!inventoryData ? (
                  <div className="chx-feedback">
                    Reload inventory first. Availability sync uses the currently loaded
                    property together with the saved room type mappings.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      Use this area for manual ARI testing. You can send availability only,
                      rates and restrictions only, or launch the full sync sequence that
                      certification expects: one availability call plus one rates and restrictions call.
                      The separate certification button always uses a fixed 500-day horizon from today.
                      Every successful ARI send below also shows the Channex task IDs you need to
                      keep for certification.
                    </div>

                    <div className="chx-ariToolbar">
                      <div className="chx-dateGrid">
                        <div>
                          <label className="chx-fieldLabel" htmlFor="chx-availability-date-from">
                            Date From
                          </label>
                          <input
                            id="chx-availability-date-from"
                            type="date"
                            className="form-control chx-input"
                            value={availabilityDateFrom}
                            onChange={(event) => setAvailabilityDateFrom(event.target.value)}
                            disabled={
                              availabilitySyncing ||
                              availabilityVerifying ||
                              restrictionsSyncing ||
                              fullSyncing
                            }
                          />
                        </div>

                        <div>
                          <label className="chx-fieldLabel" htmlFor="chx-availability-date-to">
                            Date To
                          </label>
                          <input
                            id="chx-availability-date-to"
                            type="date"
                            className="form-control chx-input"
                            value={availabilityDateTo}
                            onChange={(event) => setAvailabilityDateTo(event.target.value)}
                            disabled={
                              availabilitySyncing ||
                              availabilityVerifying ||
                              restrictionsSyncing ||
                              fullSyncing
                            }
                          />
                        </div>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={handleAvailabilitySync}
                          disabled={
                            availabilitySyncing ||
                            availabilityVerifying ||
                            restrictionsSyncing ||
                            fullSyncing ||
                            !selectedInventoryPropertyId ||
                            !availabilityDateFrom ||
                            !availabilityDateTo
                          }
                        >
                          {availabilitySyncing ? "Sending..." : "Send Availability"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleAvailabilityVerify}
                          disabled={
                            availabilityVerifying ||
                            availabilitySyncing ||
                            restrictionsSyncing ||
                            fullSyncing ||
                            !selectedInventoryPropertyId ||
                            !availabilityDateFrom ||
                            !availabilityDateTo
                          }
                        >
                          {availabilityVerifying ? "Verifying..." : "Verify Availability"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleRestrictionsSync}
                          disabled={
                            availabilitySyncing ||
                            availabilityVerifying ||
                            restrictionsSyncing ||
                            fullSyncing ||
                            !selectedInventoryPropertyId ||
                            !availabilityDateFrom ||
                            !availabilityDateTo
                          }
                        >
                          {restrictionsSyncing ? "Sending..." : "Send Rates & Restrictions"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn"
                          onClick={handleFullSync}
                          disabled={
                            availabilitySyncing ||
                            availabilityVerifying ||
                            restrictionsSyncing ||
                            fullSyncing ||
                            !selectedInventoryPropertyId ||
                            !availabilityDateFrom ||
                            !availabilityDateTo
                          }
                        >
                          {fullSyncing ? "Running..." : "Run Full Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleCertificationFullSync}
                          disabled={
                            availabilitySyncing ||
                            availabilityVerifying ||
                            restrictionsSyncing ||
                            fullSyncing ||
                            !selectedInventoryPropertyId
                          }
                          title="Runs today through today + 499 days, regardless of the manual date fields."
                        >
                          {fullSyncing ? "Running..." : "Run Certification Full Sync (500 days)"}
                        </button>
                      </div>
                    </div>

                    <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                      <span className="chx-chip">
                        Selected: {selectedInventoryMapping?.propertyTitle || inventoryData.property?.title}
                      </span>
                      <span className="chx-chip chx-chip--success">
                        BU: {selectedInventoryMapping?.businessUnit?.name || inventoryData.mapping?.businessUnit?.name}
                      </span>
                      <span className="chx-chip">
                        {inventoryData.roomTypeMappingsCount} mapped room types
                      </span>
                    </div>

                    <div className="chx-miniPanel" style={{ marginBottom: 12 }}>
                      <div className="chx-miniHeader">
                        <div className="chx-miniTitle">Send Selected Pending ARI</div>
                        <span className="chx-chip">
                          {pendingAriRecentBatchesForProperty.length}
                        </span>
                      </div>

                      <div className="chx-note" style={{ marginBottom: 12 }}>
                        Choose which pending queues to send from here. This uses pending
                        outbox changes instead of rebuilding the full selected date range.
                      </div>

                      <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                        {[
                          { key: "availability", label: "Availability" },
                          { key: "stop_sell", label: "Stop Sell" },
                          { key: "los", label: "Min / Max Stay" },
                          { key: "price", label: "Price" },
                        ].map((scope) => (
                          <label
                            key={scope.key}
                            className={`chx-chip ${
                              selectedPendingAriScopes?.[scope.key]
                                ? "chx-chip--success"
                                : "chx-chip--muted"
                            }`}
                            style={{ display: "inline-flex", alignItems: "center", gap: 6, cursor: "pointer" }}
                          >
                            <input
                              type="checkbox"
                              checked={Boolean(selectedPendingAriScopes?.[scope.key])}
                              onChange={() => handleTogglePendingAriScope(scope.key)}
                              disabled={pendingAriSending}
                            />
                            <span>{scope.label}</span>
                          </label>
                        ))}
                      </div>

                      <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                        <span className="chx-chip">
                          Availability pending {Number(autoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Stop sell pending {Number(stopSellAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Min / Max stay pending {Number(losAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Price pending {Number(priceAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleSendSelectedPendingAriChanges}
                          disabled={pendingAriSending}
                        >
                          {pendingAriSending ? "Sending Selected..." : "Send Selected Pending ARI"}
                        </button>
                      </div>
                    </div>

                    {pendingAriError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {pendingAriError}
                      </div>
                    ) : null}

                    {pendingAriMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {pendingAriMessage}
                      </div>
                    ) : null}

                    {(pendingAriResult || pendingAriRecentBatchesForProperty.length > 0) ? (
                      <div className="chx-inventoryGrid" style={{ marginBottom: 12 }}>
                        {pendingAriResult ? (
                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Latest Selected Pending ARI Result</div>
                              <span className="chx-chip">
                                {Number(pendingAriResult?.summary?.remoteTaskCount || 0)}
                              </span>
                            </div>

                            <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                              <span className="chx-chip">
                                Selected: {(pendingAriResult?.summary?.selectedScopes || []).join(", ") || "none"}
                              </span>
                              <span
                                className={`chx-chip ${
                                  pendingAriResult?.availability?.processed ? "chx-chip--success" : "chx-chip--muted"
                                }`}
                              >
                                Availability {pendingAriResult?.availability?.processed ? "sent" : "none"}
                              </span>
                              <span
                                className={`chx-chip ${
                                  pendingAriResult?.restrictions?.processed ? "chx-chip--success" : "chx-chip--muted"
                                }`}
                              >
                                Restrictions {pendingAriResult?.restrictions?.processed ? "sent" : "none"}
                              </span>
                              <span className="chx-chip">
                                Restrictions payload {Number(pendingAriResult?.restrictions?.payloadItemsCount || 0)}
                              </span>
                            </div>

                            <TaskIdsBlock
                              tasks={pendingAriResult?.availability?.remote?.tasks}
                              title="Availability call"
                            />
                            <TaskIdsBlock
                              tasks={pendingAriResult?.restrictions?.remote?.tasks}
                              title="Rates & restrictions call"
                              style={{ marginTop: 12 }}
                            />
                          </div>
                        ) : null}

                        <div className="chx-miniPanel">
                          <div className="chx-miniHeader">
                            <div className="chx-miniTitle">Recent Batches</div>
                            <span className="chx-chip">{pendingAriRecentBatchesForProperty.length}</span>
                          </div>

                          {pendingAriRecentBatchesForProperty.length > 0 ? (
                            <div className="chx-miniList">
                              {pendingAriRecentBatchesForProperty.map((batch) => (
                                <div className="chx-miniRow" key={batch.id}>
                                  <div className="chx-miniRowTitle">
                                    Pending ARI batch{" "}
                                    <span
                                      className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                      style={{ marginLeft: 8 }}
                                    >
                                      {batch.status}
                                    </span>
                                  </div>
                                  <div className="chx-miniRowMeta">
                                    {buildPendingAriBatchMeta(batch) || "No batch details available."}
                                  </div>
                                  <TaskIdsBlock
                                    tasks={batch.availabilityTasks}
                                    title="Availability call"
                                    style={{ marginTop: 8 }}
                                  />
                                  <TaskIdsBlock
                                    tasks={batch.restrictionsTasks}
                                    title="Rates & restrictions call"
                                    style={{ marginTop: 8 }}
                                  />
                                  {Array.isArray(batch.errors) && batch.errors.length > 0 ? (
                                    <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                      {batch.errors
                                        .map((item) => item?.message)
                                        .filter(Boolean)
                                        .join(" ")}
                                    </div>
                                  ) : null}
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="chx-miniEmpty">
                              No selected pending ARI batches yet.
                            </div>
                          )}
                        </div>
                      </div>
                    ) : null}

                    {availabilitySyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {availabilitySyncError}
                      </div>
                    ) : null}

                    {availabilitySyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {availabilitySyncMessage}
                      </div>
                    ) : null}

                    {availabilityVerifyError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {availabilityVerifyError}
                      </div>
                    ) : null}

                    {availabilityVerifyMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {availabilityVerifyMessage}
                      </div>
                    ) : null}

                    {restrictionsSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {restrictionsSyncError}
                      </div>
                    ) : null}

                    {restrictionsSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {restrictionsSyncMessage}
                      </div>
                    ) : null}

                    {fullSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {fullSyncError}
                      </div>
                    ) : null}

                    {fullSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {fullSyncMessage}
                      </div>
                    ) : null}

                    {fullSyncResult ? (
                      <>
                        <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                          <span className="chx-chip chx-chip--success">
                            Availability payload {Number(fullSyncResult?.summary?.availabilityPayloadItemsCount || 0)}
                          </span>
                          <span className="chx-chip chx-chip--success">
                            Restrictions payload {Number(fullSyncResult?.summary?.restrictionsPayloadItemsCount || 0)}
                          </span>
                          <span className="chx-chip">
                            Room types {Number(fullSyncResult?.summary?.availabilitySyncedRoomTypesCount || 0)}
                          </span>
                          <span className="chx-chip">
                            Rate plans {Number(fullSyncResult?.summary?.restrictionsSyncedRatePlansCount || 0)}
                          </span>
                        </div>
                        <div className="chx-inventoryGrid" style={{ marginBottom: 12 }}>
                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Certification Task IDs</div>
                              <span className="chx-chip chx-chip--success">
                                {Number(fullSyncResult?.summary?.remoteTaskCount || 0)}
                              </span>
                            </div>
                            <TaskIdsBlock
                              tasks={fullSyncResult?.availability?.remote?.tasks}
                              title="Availability call"
                            />
                            <TaskIdsBlock
                              tasks={fullSyncResult?.restrictions?.remote?.tasks}
                              title="Rates & restrictions call"
                              style={{ marginTop: 12 }}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}

                    {availabilitySyncResult ? (
                      <>
                        <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                          <span className="chx-chip chx-chip--success">
                            {availabilitySyncResult.payloadItemsCount} payload item
                            {Number(availabilitySyncResult.payloadItemsCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip chx-chip--success">
                            {availabilitySyncResult.syncedRoomTypesCount} synced room type
                            {Number(availabilitySyncResult.syncedRoomTypesCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip">
                            {availabilitySyncResult.syncedDatesCount} synced day
                            {Number(availabilitySyncResult.syncedDatesCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip chx-chip--muted">
                            {availabilitySyncResult.skippedRoomTypesCount} skipped
                          </span>
                        </div>

                        <TaskIdsBlock
                          tasks={availabilitySyncResult?.remote?.tasks}
                          style={{ marginBottom: 12 }}
                        />

                        <div className="chx-inventoryGrid">
                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Synced Room Types</div>
                              <span className="chx-chip">
                                {availabilitySyncResult.syncedRoomTypesCount}
                              </span>
                            </div>

                            {availabilitySyncResult.syncedRoomTypes?.length ? (
                              <div className="chx-miniList">
                                {availabilitySyncResult.syncedRoomTypes.map((item) => (
                                  <div className="chx-miniRow" key={item.roomTypeId || item.roomTypeTitle}>
                                    <div className="chx-miniRowTitle">{item.roomTypeTitle}</div>
                                    <div className="chx-miniRowMeta">
                                      {buildAvailabilitySyncRoomTypeMeta(item) ||
                                        "Availability payload built successfully."}
                                    </div>
                                  </div>
                                ))}
                              </div>
                            ) : (
                              <div className="chx-miniEmpty">No room types were synced.</div>
                            )}
                          </div>

                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Warnings and Skips</div>
                              <span className="chx-chip">
                                {Number(availabilitySyncResult.warningsCount || 0) +
                                  Number(availabilitySyncResult.skippedRoomTypesCount || 0)}
                              </span>
                            </div>

                            {availabilitySyncResult.warnings?.length ||
                            availabilitySyncResult.skippedRoomTypes?.length ||
                            availabilitySyncResult.remote?.warnings?.length ? (
                              <div className="chx-miniList">
                                {(availabilitySyncResult.warnings || []).map((warning, index) => (
                                  <div
                                    className="chx-miniRow"
                                    key={`warning-${warning.roomTypeId || index}`}
                                  >
                                    <div className="chx-miniRowTitle">
                                      {warning.reason || "Warning"}
                                    </div>
                                    <div className="chx-miniRowMeta">
                                      {buildAvailabilitySyncWarningMeta(warning) ||
                                        "Availability sync warning."}
                                    </div>
                                  </div>
                                ))}

                                {(availabilitySyncResult.skippedRoomTypes || []).map((item) => (
                                  <div className="chx-miniRow" key={`skipped-${item.roomTypeId}`}>
                                    <div className="chx-miniRowTitle">{item.reason}</div>
                                    <div className="chx-miniRowMeta">
                                      {[item.roomTypeTitle, item.roomCategoryName]
                                        .filter(Boolean)
                                        .join(" | ") || "Skipped room type."}
                                    </div>
                                  </div>
                                ))}

                                {(availabilitySyncResult.remote?.warnings || []).map(
                                  (warning, index) => (
                                    <div className="chx-miniRow" key={`remote-warning-${index}`}>
                                      <div className="chx-miniRowTitle">
                                        Channex returned a warning
                                      </div>
                                      <div className="chx-miniRowMeta">
                                        {typeof warning === "string"
                                          ? warning
                                          : JSON.stringify(warning)}
                                      </div>
                                    </div>
                                  )
                                )}
                              </div>
                            ) : (
                              <div className="chx-miniEmpty">
                                No warnings. Availability was prepared and sent cleanly.
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : (
                      <div className="chx-feedback">
                        Send a manual availability sync once the property, room types and
                        mappings are ready.
                      </div>
                    )}

                    {availabilityVerifyResult ? (
                      <>
                        <div className="chx-chipRow" style={{ marginTop: 14, marginBottom: 12 }}>
                          <span className="chx-chip chx-chip--success">
                            {availabilityVerifyResult.matchedRoomTypesCount} matched room type
                            {Number(availabilityVerifyResult.matchedRoomTypesCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip">
                            {availabilityVerifyResult.mismatchedRoomTypesCount} mismatched room type
                            {Number(availabilityVerifyResult.mismatchedRoomTypesCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip">
                            {availabilityVerifyResult.mismatchesCount} mismatched day
                            {Number(availabilityVerifyResult.mismatchesCount) === 1 ? "" : "s"}
                          </span>
                          <span className="chx-chip chx-chip--muted">
                            {availabilityVerifyResult.missingRemoteDatesCount} missing remote day
                            {Number(availabilityVerifyResult.missingRemoteDatesCount) === 1 ? "" : "s"}
                          </span>
                        </div>

                        <div className="chx-inventoryGrid">
                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Verification Summary</div>
                              <span className="chx-chip">
                                {availabilityVerifyResult.verifiedRoomTypesCount}
                              </span>
                            </div>

                            <div className="chx-miniList">
                              {(availabilityVerifyResult.roomTypes || []).map((item) => (
                                <div className="chx-miniRow" key={`verify-${item.roomTypeId}`}>
                                  <div className="chx-miniRowTitle">
                                    {item.roomTypeTitle}{" "}
                                    <span
                                      className={`chx-chip ${
                                        item.status === "matched"
                                          ? "chx-chip--success"
                                          : "chx-chip--muted"
                                      }`}
                                      style={{ marginLeft: 8 }}
                                    >
                                      {item.status}
                                    </span>
                                  </div>
                                  <div className="chx-miniRowMeta">
                                    {buildAvailabilityVerifyRoomTypeMeta(item) ||
                                      "Verification completed."}
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="chx-miniPanel">
                            <div className="chx-miniHeader">
                              <div className="chx-miniTitle">Mismatch Samples</div>
                              <span className="chx-chip">
                                {availabilityVerifyResult.mismatchesCount}
                              </span>
                            </div>

                            {(availabilityVerifyResult.roomTypes || []).some(
                              (item) =>
                                (item.mismatches && item.mismatches.length > 0) ||
                                (item.missingRemoteDates && item.missingRemoteDates.length > 0) ||
                                (item.missingLocalDates && item.missingLocalDates.length > 0)
                            ) ? (
                              <div className="chx-miniList">
                                {(availabilityVerifyResult.roomTypes || []).map((item) => {
                                  const firstMismatch = item.mismatches?.[0] || null;
                                  const firstMissingRemoteDate = item.missingRemoteDates?.[0] || null;
                                  const firstMissingLocalDate = item.missingLocalDates?.[0] || null;

                                  if (!firstMismatch && !firstMissingRemoteDate && !firstMissingLocalDate) {
                                    return null;
                                  }

                                  return (
                                    <div className="chx-miniRow" key={`verify-sample-${item.roomTypeId}`}>
                                      <div className="chx-miniRowTitle">{item.roomTypeTitle}</div>
                                      <div className="chx-miniRowMeta">
                                        {firstMismatch
                                          ? `Date ${firstMismatch.date}: Pilcore ${firstMismatch.localAvailability}, Channex ${firstMismatch.remoteAvailability}`
                                          : firstMissingRemoteDate
                                            ? `Missing remote date: ${firstMissingRemoteDate}`
                                            : `Missing local date: ${firstMissingLocalDate}`}
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            ) : (
                              <div className="chx-miniEmpty">
                                No mismatch samples. Channex matches Pilcore for the selected range.
                              </div>
                            )}
                          </div>
                        </div>
                      </>
                    ) : null}

                    {restrictionsSyncResult ? (
                      <div className="chx-inventoryGrid" style={{ marginTop: 12 }}>
                        <div className="chx-miniPanel">
                          <div className="chx-miniHeader">
                            <div className="chx-miniTitle">Synced Rates And Restrictions</div>
                            <span className="chx-chip">
                              {Number(restrictionsSyncResult?.syncedRatePlansCount || 0)}
                            </span>
                          </div>

                          <div className="chx-chipRow" style={{ marginBottom: 12 }}>
                            <span className="chx-chip chx-chip--success">
                              {Number(restrictionsSyncResult?.payloadItemsCount || 0)} payload item
                              {Number(restrictionsSyncResult?.payloadItemsCount || 0) === 1 ? "" : "s"}
                            </span>
                            <span className="chx-chip chx-chip--success">
                              {Number(restrictionsSyncResult?.syncedRatePlansCount || 0)} synced rate plan
                              {Number(restrictionsSyncResult?.syncedRatePlansCount || 0) === 1 ? "" : "s"}
                            </span>
                            <span className="chx-chip">
                              {Number(restrictionsSyncResult?.syncedDatesCount || 0)} day states
                            </span>
                            <span className="chx-chip">
                              Min stay {restrictionsSyncResult?.minStayType || "unknown"}
                            </span>
                          </div>

                          <TaskIdsBlock
                            tasks={restrictionsSyncResult?.remote?.tasks}
                            style={{ marginBottom: 12 }}
                          />

                          {restrictionsSyncResult?.syncedRatePlans?.length ? (
                            <div className="chx-miniList">
                              {restrictionsSyncResult.syncedRatePlans.map((item) => (
                                <div className="chx-miniRow" key={item.ratePlanId || item.ratePlanTitle}>
                                  <div className="chx-miniRowTitle">{item.ratePlanTitle}</div>
                                  <div className="chx-miniRowMeta">
                                    {buildRestrictionsSyncRatePlanMeta(item) ||
                                      "Rates and restrictions payload built successfully."}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="chx-miniEmpty">No rate plans were synced.</div>
                          )}
                        </div>

                        <div className="chx-miniPanel">
                          <div className="chx-miniHeader">
                            <div className="chx-miniTitle">Warnings</div>
                            <span className="chx-chip">
                              {Number(restrictionsSyncResult?.warningsCount || 0)}
                            </span>
                          </div>

                          {restrictionsSyncResult?.warnings?.length ? (
                            <div className="chx-miniList">
                              {restrictionsSyncResult.warnings.slice(0, 20).map((warning, index) => (
                                <div className="chx-miniRow" key={`${warning.ratePlanId || "warn"}-${warning.stayDate || index}`}>
                                  <div className="chx-miniRowTitle">
                                    {warning.ratePlanTitle || warning.roomRateTitle || "Restriction warning"}
                                  </div>
                                  <div className="chx-miniRowMeta">
                                    {[warning.stayDate, warning.reason].filter(Boolean).join(" | ")}
                                  </div>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div className="chx-miniEmpty">No warnings for this restrictions sync.</div>
                          )}
                        </div>
                      </div>
                    ) : null}
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 5</div>
                <h3 className="chx-sectionTitle">Auto Availability Sync</h3>
                <div className="chx-sectionSubtitle">
                  Enable near-real-time availability batches and monitor the latest delivery
                  state for the selected property.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Auto sync status is tracked per Channex
                    property.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      Auto sync watches Pilcore availability changes, groups them into batches
                      and sends them to Channex without needing the manual button.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(autoSyncStatus)
                          )}`}
                        >
                          {autoSyncStatus?.enabled ? "Enabled" : "Disabled"}
                        </span>
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(autoSyncStatus)
                          )}`}
                        >
                          Current: {getAutoSyncCurrentStatus(autoSyncStatus)}
                        </span>
                        <span className="chx-chip">
                          Pending: {Number(autoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Processing: {Number(autoSyncStatus?.processingRowsCount || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            getAutoSyncHistoricalErrorRowsCount(autoSyncStatus) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Historical errors: {getAutoSyncHistoricalErrorRowsCount(autoSyncStatus)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={() => handleSetAutoSyncEnabled(true)}
                          disabled={
                            autoSyncUpdating ||
                            autoSyncLoading ||
                            autoSyncSendingPending ||
                            autoSyncStatus?.enabled
                          }
                        >
                          {autoSyncUpdating && !autoSyncStatus?.enabled ? "Enabling..." : "Enable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => handleSetAutoSyncEnabled(false)}
                          disabled={
                            autoSyncUpdating ||
                            autoSyncLoading ||
                            autoSyncSendingPending ||
                            !autoSyncStatus?.enabled
                          }
                        >
                          {autoSyncUpdating && autoSyncStatus?.enabled ? "Disabling..." : "Disable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleSendPendingAvailabilityChanges}
                          disabled={autoSyncStatus?.enabled}
                        >
                          {autoSyncSendingPending ? "Sending Pending..." : "Send Pending Changes"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => loadAutoSyncStatus()}
                          disabled={autoSyncLoading || autoSyncUpdating || autoSyncSendingPending}
                        >
                          {autoSyncLoading ? "Refreshing..." : "Refresh Status"}
                        </button>
                      </div>
                    </div>

                    {autoSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {autoSyncError}
                      </div>
                    ) : null}

                    {autoSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {autoSyncMessage}
                      </div>
                    ) : null}

                    <div className="chx-inventoryGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Current State</div>
                          <span
                            className={`chx-chip ${getAutoSyncStatusChipClass(
                              getAutoSyncCurrentStatus(autoSyncStatus)
                            )}`}
                          >
                            {getAutoSyncCurrentStatus(autoSyncStatus)}
                          </span>
                        </div>

                        <div className="chx-miniList">
                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last successful sync</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(autoSyncStatus?.lastSuccessAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last batch activity</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(autoSyncStatus?.lastBatchAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Historical error rows</div>
                            <div className="chx-miniRowMeta">
                              {getAutoSyncHistoricalErrorRowsCount(autoSyncStatus)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Latest batch</div>
                            <div className="chx-miniRowMeta">
                              {autoSyncStatus?.latestBatch
                                ? buildAutoSyncBatchMeta(autoSyncStatus.latestBatch)
                                : "No batches recorded yet."}
                            </div>
                          </div>

                          {normalizeRemoteTasks(autoSyncStatus?.latestBatch?.remoteTasks).length ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest batch task IDs</div>
                              <div className="chx-miniRowMeta" style={{ display: "block" }}>
                                <TaskIdsBlock tasks={autoSyncStatus?.latestBatch?.remoteTasks} title="Availability" />
                              </div>
                            </div>
                          ) : null}

                          {autoSyncStatus?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest recorded error</div>
                              <div className="chx-miniRowMeta">{autoSyncStatus.lastError}</div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Recent Batches</div>
                          <span className="chx-chip">
                            {Array.isArray(autoSyncStatus?.recentBatches)
                              ? autoSyncStatus.recentBatches.length
                              : 0}
                          </span>
                        </div>

                        {autoSyncLoading && !autoSyncStatus ? (
                          <div className="chx-miniEmpty">Loading auto-sync status...</div>
                        ) : Array.isArray(autoSyncStatus?.recentBatches) &&
                          autoSyncStatus.recentBatches.length > 0 ? (
                          <div className="chx-miniList">
                            {autoSyncStatus.recentBatches.map((batch) => (
                              <div className="chx-miniRow" key={`batch-${batch.id}`}>
                                <div className="chx-miniRowTitle">
                                  Batch #{batch.id}{" "}
                                  <span
                                    className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {batch.status}
                                  </span>
                                </div>
                                <div className="chx-miniRowMeta">
                                  {buildAutoSyncBatchMeta(batch) || "No batch details available."}
                                </div>
                                <TaskIdsBlock tasks={batch.remoteTasks} title="Task IDs" style={{ marginTop: 8 }} />
                                {batch.lastError ? (
                                  <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                    {batch.lastError}
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="chx-miniEmpty">
                            No auto-sync batches yet. Enable auto sync to start tracking them.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 6</div>
                <h3 className="chx-sectionTitle">Auto Stop Sell Sync</h3>
                <div className="chx-sectionSubtitle">
                  Watch Pilcore stop sells for mapped rate plans and send Channex
                  restrictions automatically with batch status tracking.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Stop-sell sync status is tracked per
                    Channex property.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      This step only uses mapped rate plans. Manual and automatic stop sells
                      in Pilcore are queued and delivered to Channex as `stop_sell`
                      restrictions.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(stopSellAutoSyncStatus)
                          )}`}
                        >
                          {stopSellAutoSyncStatus?.enabled ? "Enabled" : "Disabled"}
                        </span>
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(stopSellAutoSyncStatus)
                          )}`}
                        >
                          Current: {getAutoSyncCurrentStatus(stopSellAutoSyncStatus)}
                        </span>
                        <span className="chx-chip">
                          Pending: {Number(stopSellAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Processing: {Number(stopSellAutoSyncStatus?.processingRowsCount || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            getAutoSyncHistoricalErrorRowsCount(stopSellAutoSyncStatus) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Historical errors: {getAutoSyncHistoricalErrorRowsCount(stopSellAutoSyncStatus)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={() => handleSetStopSellAutoSyncEnabled(true)}
                          disabled={
                            stopSellAutoSyncUpdating ||
                            stopSellAutoSyncLoading ||
                            stopSellAutoSyncSendingPending ||
                            stopSellAutoSyncReconcilingErrors ||
                            stopSellAutoSyncStatus?.enabled
                          }
                        >
                          {stopSellAutoSyncUpdating && !stopSellAutoSyncStatus?.enabled
                            ? "Enabling..."
                            : "Enable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => handleSetStopSellAutoSyncEnabled(false)}
                          disabled={
                            stopSellAutoSyncUpdating ||
                            stopSellAutoSyncLoading ||
                            stopSellAutoSyncSendingPending ||
                            stopSellAutoSyncReconcilingErrors ||
                            !stopSellAutoSyncStatus?.enabled
                          }
                        >
                          {stopSellAutoSyncUpdating && stopSellAutoSyncStatus?.enabled
                            ? "Disabling..."
                            : "Disable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleSendPendingStopSellChanges}
                          disabled={
                            stopSellAutoSyncStatus?.enabled ||
                            stopSellAutoSyncSendingPending ||
                            stopSellAutoSyncReconcilingErrors
                          }
                        >
                          {stopSellAutoSyncSendingPending
                            ? "Sending Pending..."
                            : "Send Pending Changes"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleReconcileStopSellErrors}
                          disabled={
                            stopSellAutoSyncReconcilingErrors ||
                            stopSellAutoSyncSendingPending ||
                            stopSellAutoSyncLoading ||
                            Number(getAutoSyncHistoricalErrorRowsCount(stopSellAutoSyncStatus)) === 0 ||
                            Number(stopSellAutoSyncStatus?.processingRowsCount || 0) > 0
                          }
                        >
                          {stopSellAutoSyncReconcilingErrors
                            ? "Reconciling..."
                            : "Reconcile Errors"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => loadStopSellAutoSyncStatus()}
                          disabled={
                            stopSellAutoSyncLoading ||
                            stopSellAutoSyncUpdating ||
                            stopSellAutoSyncSendingPending ||
                            stopSellAutoSyncReconcilingErrors
                          }
                        >
                          {stopSellAutoSyncLoading ? "Refreshing..." : "Refresh Status"}
                        </button>
                      </div>
                    </div>

                    {stopSellAutoSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {stopSellAutoSyncError}
                      </div>
                    ) : null}

                    {stopSellAutoSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {stopSellAutoSyncMessage}
                      </div>
                    ) : null}

                    <div className="chx-inventoryGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Current State</div>
                          <span
                            className={`chx-chip ${getAutoSyncStatusChipClass(
                              getAutoSyncCurrentStatus(stopSellAutoSyncStatus)
                            )}`}
                          >
                            {getAutoSyncCurrentStatus(stopSellAutoSyncStatus)}
                          </span>
                        </div>

                        <div className="chx-miniList">
                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last successful sync</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(stopSellAutoSyncStatus?.lastSuccessAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last batch activity</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(stopSellAutoSyncStatus?.lastBatchAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Historical error rows</div>
                            <div className="chx-miniRowMeta">
                              {getAutoSyncHistoricalErrorRowsCount(stopSellAutoSyncStatus)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Latest batch</div>
                            <div className="chx-miniRowMeta">
                              {stopSellAutoSyncStatus?.latestBatch
                                ? buildStopSellBatchMeta(stopSellAutoSyncStatus.latestBatch)
                                : "No batches recorded yet."}
                            </div>
                          </div>

                          {normalizeRemoteTasks(stopSellAutoSyncStatus?.latestBatch?.remoteTasks).length ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest batch task IDs</div>
                              <div className="chx-miniRowMeta" style={{ display: "block" }}>
                                <TaskIdsBlock tasks={stopSellAutoSyncStatus?.latestBatch?.remoteTasks} title="Stop sell" />
                              </div>
                            </div>
                          ) : null}

                          {stopSellAutoSyncStatus?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest recorded error</div>
                              <div className="chx-miniRowMeta">
                                {stopSellAutoSyncStatus.lastError}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Recent Batches</div>
                          <span className="chx-chip">
                            {Array.isArray(stopSellAutoSyncStatus?.recentBatches)
                              ? stopSellAutoSyncStatus.recentBatches.length
                              : 0}
                          </span>
                        </div>

                        {stopSellAutoSyncLoading && !stopSellAutoSyncStatus ? (
                          <div className="chx-miniEmpty">Loading stop-sell status...</div>
                        ) : Array.isArray(stopSellAutoSyncStatus?.recentBatches) &&
                          stopSellAutoSyncStatus.recentBatches.length > 0 ? (
                          <div className="chx-miniList">
                            {stopSellAutoSyncStatus.recentBatches.map((batch) => (
                              <div className="chx-miniRow" key={`stop-sell-batch-${batch.id}`}>
                                <div className="chx-miniRowTitle">
                                  Batch #{batch.id}{" "}
                                  <span
                                    className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {batch.status}
                                  </span>
                                </div>
                                <div className="chx-miniRowMeta">
                                  {buildStopSellBatchMeta(batch) || "No batch details available."}
                                </div>
                                <TaskIdsBlock tasks={batch.remoteTasks} title="Task IDs" style={{ marginTop: 8 }} />
                                {batch.lastError ? (
                                  <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                    {batch.lastError}
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="chx-miniEmpty">
                            No stop-sell batches yet. Enable auto sync to start tracking them.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 7</div>
                <h3 className="chx-sectionTitle">Auto Min / Max Stay Sync</h3>
                <div className="chx-sectionSubtitle">
                  Watch Pilcore `min_stay` and `max_stay` changes on mapped rate plans
                  and send Channex restrictions automatically with batch status
                  tracking.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Min/max stay sync status is tracked
                    per Channex property.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      Empty Pilcore `min_stay` is sent as `1`. Empty Pilcore `max_stay`
                      is sent as `0`. If Channex property `min_stay_type` is `both`,
                      Pilcore single `min_stay` value is mirrored to both arrival and
                      through restrictions.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(losAutoSyncStatus)
                          )}`}
                        >
                          {losAutoSyncStatus?.enabled ? "Enabled" : "Disabled"}
                        </span>
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(losAutoSyncStatus)
                          )}`}
                        >
                          Current: {getAutoSyncCurrentStatus(losAutoSyncStatus)}
                        </span>
                        <span className="chx-chip">
                          Pending: {Number(losAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Processing: {Number(losAutoSyncStatus?.processingRowsCount || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            getAutoSyncHistoricalErrorRowsCount(losAutoSyncStatus) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Historical errors: {getAutoSyncHistoricalErrorRowsCount(losAutoSyncStatus)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={() => handleSetLosAutoSyncEnabled(true)}
                          disabled={
                            losAutoSyncUpdating ||
                            losAutoSyncLoading ||
                            losAutoSyncSendingPending ||
                            losAutoSyncStatus?.enabled
                          }
                        >
                          {losAutoSyncUpdating && !losAutoSyncStatus?.enabled
                            ? "Enabling..."
                            : "Enable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => handleSetLosAutoSyncEnabled(false)}
                          disabled={
                            losAutoSyncUpdating ||
                            losAutoSyncLoading ||
                            losAutoSyncSendingPending ||
                            !losAutoSyncStatus?.enabled
                          }
                        >
                          {losAutoSyncUpdating && losAutoSyncStatus?.enabled
                            ? "Disabling..."
                            : "Disable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleSendPendingLosChanges}
                          disabled={losAutoSyncStatus?.enabled}
                        >
                          {losAutoSyncSendingPending ? "Sending Pending..." : "Send Pending Changes"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => loadLosAutoSyncStatus()}
                          disabled={
                            losAutoSyncLoading ||
                            losAutoSyncUpdating ||
                            losAutoSyncSendingPending
                          }
                        >
                          {losAutoSyncLoading ? "Refreshing..." : "Refresh Status"}
                        </button>
                      </div>
                    </div>

                    {losAutoSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {losAutoSyncError}
                      </div>
                    ) : null}

                    {losAutoSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {losAutoSyncMessage}
                      </div>
                    ) : null}

                    <div className="chx-inventoryGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Current State</div>
                          <span
                            className={`chx-chip ${getAutoSyncStatusChipClass(
                              getAutoSyncCurrentStatus(losAutoSyncStatus)
                            )}`}
                          >
                            {getAutoSyncCurrentStatus(losAutoSyncStatus)}
                          </span>
                        </div>

                        <div className="chx-miniList">
                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Channex min stay mode</div>
                            <div className="chx-miniRowMeta">
                              {losAutoSyncStatus?.minStayType || "Unknown"}
                              {Array.isArray(losAutoSyncStatus?.minStayKeys) &&
                              losAutoSyncStatus.minStayKeys.length > 0
                                ? ` | ${losAutoSyncStatus.minStayKeys.join(" + ")}`
                                : ""}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Write strategy</div>
                            <div className="chx-miniRowMeta">
                              {losAutoSyncStatus?.minStayStrategy || "Unknown"}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last successful sync</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(losAutoSyncStatus?.lastSuccessAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last batch activity</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(losAutoSyncStatus?.lastBatchAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Historical error rows</div>
                            <div className="chx-miniRowMeta">
                              {getAutoSyncHistoricalErrorRowsCount(losAutoSyncStatus)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Latest batch</div>
                            <div className="chx-miniRowMeta">
                              {losAutoSyncStatus?.latestBatch
                                ? buildLosBatchMeta(losAutoSyncStatus.latestBatch)
                                : "No batches recorded yet."}
                            </div>
                          </div>

                          {normalizeRemoteTasks(losAutoSyncStatus?.latestBatch?.remoteTasks).length ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest batch task IDs</div>
                              <div className="chx-miniRowMeta" style={{ display: "block" }}>
                                <TaskIdsBlock tasks={losAutoSyncStatus?.latestBatch?.remoteTasks} title="Min / max stay" />
                              </div>
                            </div>
                          ) : null}

                          {losAutoSyncStatus?.remoteConfigError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Remote config error</div>
                              <div className="chx-miniRowMeta">
                                {losAutoSyncStatus.remoteConfigError}
                              </div>
                            </div>
                          ) : null}

                          {losAutoSyncStatus?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest recorded error</div>
                              <div className="chx-miniRowMeta">
                                {losAutoSyncStatus.lastError}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Recent Batches</div>
                          <span className="chx-chip">
                            {Array.isArray(losAutoSyncStatus?.recentBatches)
                              ? losAutoSyncStatus.recentBatches.length
                              : 0}
                          </span>
                        </div>

                        {losAutoSyncLoading && !losAutoSyncStatus ? (
                          <div className="chx-miniEmpty">Loading min/max stay status...</div>
                        ) : Array.isArray(losAutoSyncStatus?.recentBatches) &&
                          losAutoSyncStatus.recentBatches.length > 0 ? (
                          <div className="chx-miniList">
                            {losAutoSyncStatus.recentBatches.map((batch) => (
                              <div className="chx-miniRow" key={`los-batch-${batch.id}`}>
                                <div className="chx-miniRowTitle">
                                  Batch #{batch.id}{" "}
                                  <span
                                    className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {batch.status}
                                  </span>
                                </div>
                                <div className="chx-miniRowMeta">
                                  {buildLosBatchMeta(batch) || "No batch details available."}
                                </div>
                                <TaskIdsBlock tasks={batch.remoteTasks} title="Task IDs" style={{ marginTop: 8 }} />
                                {batch.lastError ? (
                                  <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                    {batch.lastError}
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="chx-miniEmpty">
                            No min/max stay batches yet. Enable auto sync to start tracking them.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 8</div>
                <h3 className="chx-sectionTitle">Auto Price Sync</h3>
                <div className="chx-sectionSubtitle">
                  Watch Pilcore nightly price changes on mapped rate plans and send
                  Channex rate updates automatically with batch status tracking.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Price sync status is tracked per
                    Channex property.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      Channex requires `rate` to be greater than zero. When Pilcore has
                      no price for a mapped rate plan and date, this sync sends
                      `stop_sell: true` to avoid stale prices remaining open remotely.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(priceAutoSyncStatus)
                          )}`}
                        >
                          {priceAutoSyncStatus?.enabled ? "Enabled" : "Disabled"}
                        </span>
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            getAutoSyncCurrentStatus(priceAutoSyncStatus)
                          )}`}
                        >
                          Current: {getAutoSyncCurrentStatus(priceAutoSyncStatus)}
                        </span>
                        <span className="chx-chip">
                          Pending: {Number(priceAutoSyncStatus?.pendingRowsCount || 0)}
                        </span>
                        <span className="chx-chip">
                          Processing: {Number(priceAutoSyncStatus?.processingRowsCount || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            getAutoSyncHistoricalErrorRowsCount(priceAutoSyncStatus) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Historical errors: {getAutoSyncHistoricalErrorRowsCount(priceAutoSyncStatus)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={() => handleSetPriceAutoSyncEnabled(true)}
                          disabled={
                            priceAutoSyncUpdating ||
                            priceAutoSyncLoading ||
                            priceAutoSyncSendingPending ||
                            priceAutoSyncStatus?.enabled
                          }
                        >
                          {priceAutoSyncUpdating && !priceAutoSyncStatus?.enabled
                            ? "Enabling..."
                            : "Enable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => handleSetPriceAutoSyncEnabled(false)}
                          disabled={
                            priceAutoSyncUpdating ||
                            priceAutoSyncLoading ||
                            priceAutoSyncSendingPending ||
                            !priceAutoSyncStatus?.enabled
                          }
                        >
                          {priceAutoSyncUpdating && priceAutoSyncStatus?.enabled
                            ? "Disabling..."
                            : "Disable Auto Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleSendPendingPriceChanges}
                          disabled={priceAutoSyncStatus?.enabled}
                        >
                          {priceAutoSyncSendingPending ? "Sending Pending..." : "Send Pending Changes"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => loadPriceAutoSyncStatus()}
                          disabled={
                            priceAutoSyncLoading ||
                            priceAutoSyncUpdating ||
                            priceAutoSyncSendingPending
                          }
                        >
                          {priceAutoSyncLoading ? "Refreshing..." : "Refresh Status"}
                        </button>
                      </div>
                    </div>

                    {priceAutoSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {priceAutoSyncError}
                      </div>
                    ) : null}

                    {priceAutoSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {priceAutoSyncMessage}
                      </div>
                    ) : null}

                    <div className="chx-inventoryGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Current State</div>
                          <span
                            className={`chx-chip ${getAutoSyncStatusChipClass(
                              getAutoSyncCurrentStatus(priceAutoSyncStatus)
                            )}`}
                          >
                            {getAutoSyncCurrentStatus(priceAutoSyncStatus)}
                          </span>
                        </div>

                        <div className="chx-miniList">
                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last successful sync</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(priceAutoSyncStatus?.lastSuccessAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last batch activity</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(priceAutoSyncStatus?.lastBatchAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Historical error rows</div>
                            <div className="chx-miniRowMeta">
                              {getAutoSyncHistoricalErrorRowsCount(priceAutoSyncStatus)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Latest batch</div>
                            <div className="chx-miniRowMeta">
                              {priceAutoSyncStatus?.latestBatch
                                ? buildPriceBatchMeta(priceAutoSyncStatus.latestBatch)
                                : "No batches recorded yet."}
                            </div>
                          </div>

                          {normalizeRemoteTasks(priceAutoSyncStatus?.latestBatch?.remoteTasks).length ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest batch task IDs</div>
                              <div className="chx-miniRowMeta" style={{ display: "block" }}>
                                <TaskIdsBlock tasks={priceAutoSyncStatus?.latestBatch?.remoteTasks} title="Price" />
                              </div>
                            </div>
                          ) : null}

                          {priceAutoSyncStatus?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Latest recorded error</div>
                              <div className="chx-miniRowMeta">
                                {priceAutoSyncStatus.lastError}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Recent Batches</div>
                          <span className="chx-chip">
                            {Array.isArray(priceAutoSyncStatus?.recentBatches)
                              ? priceAutoSyncStatus.recentBatches.length
                              : 0}
                          </span>
                        </div>

                        {priceAutoSyncLoading && !priceAutoSyncStatus ? (
                          <div className="chx-miniEmpty">Loading price sync status...</div>
                        ) : Array.isArray(priceAutoSyncStatus?.recentBatches) &&
                          priceAutoSyncStatus.recentBatches.length > 0 ? (
                          <div className="chx-miniList">
                            {priceAutoSyncStatus.recentBatches.map((batch) => (
                              <div className="chx-miniRow" key={`price-batch-${batch.id}`}>
                                <div className="chx-miniRowTitle">
                                  Batch #{batch.id}{" "}
                                  <span
                                    className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {batch.status}
                                  </span>
                                </div>
                                <div className="chx-miniRowMeta">
                                  {buildPriceBatchMeta(batch) || "No batch details available."}
                                </div>
                                <TaskIdsBlock tasks={batch.remoteTasks} title="Task IDs" style={{ marginTop: 8 }} />
                                {batch.lastError ? (
                                  <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                    {batch.lastError}
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="chx-miniEmpty">
                            No price batches yet. Enable auto sync to start tracking them.
                          </div>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 9</div>
                <h3 className="chx-sectionTitle">Real-Time Bookings Import</h3>
                <div className="chx-sectionSubtitle">
                  Receive Channex booking events immediately through a webhook, fall
                  back to the revisions feed as a safety net, import or cancel the
                  reservation inside Pilcore, and acknowledge only successful
                  revisions back to Channex.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Booking revisions are processed per
                    Channex property.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      Enable real-time sync to let Channex notify Pilcore immediately
                      on create, modify, or cancel. Pilcore still keeps a backup pull
                      of `booking_revisions/feed` running in the background so we do
                      not miss revisions if a webhook ever fails. Successful imports
                      are acknowledged only after the local reservation change
                      succeeds. For certification on bookings, save the booking and revision IDs
                      shown below rather than a Channex task ID.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            bookingsSyncStatus?.autoSync?.enabled
                              ? bookingsSyncStatus?.summary?.status || "idle"
                              : "disabled"
                          )}`}
                        >
                          {bookingsSyncStatus?.autoSync?.enabled ? "Enabled" : "Disabled"}
                        </span>
                        <span
                          className={`chx-chip ${getAutoSyncStatusChipClass(
                            bookingsSyncStatus?.summary?.status || "idle"
                          )}`}
                        >
                          Status: {bookingsSyncStatus?.summary?.status || "idle"}
                        </span>
                        <span className="chx-chip">
                          Webhook:{" "}
                          {bookingsSyncStatus?.webhook?.enabled &&
                          bookingsSyncStatus?.webhook?.webhookId &&
                          bookingsSyncStatus?.webhook?.callbackUrl
                            ? "Ready"
                            : "Missing"}
                        </span>
                        <span className="chx-chip">
                          Backup pull:{" "}
                          {Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) > 0 &&
                          Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) % 60 === 0
                            ? `${Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) / 60}m`
                            : `${Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0)}s`}
                        </span>
                        <span className="chx-chip">
                          Tracked: {Number(bookingsSyncStatus?.summary?.totalTracked || 0)}
                        </span>
                        <span className="chx-chip">
                          Pending import: {Number(bookingsSyncStatus?.summary?.pendingImport || 0)}
                        </span>
                        <span className="chx-chip">
                          Pending ack: {Number(bookingsSyncStatus?.summary?.pendingAck || 0)}
                        </span>
                        <span className="chx-chip">
                          Imported: {Number(bookingsSyncStatus?.summary?.imported || 0)}
                        </span>
                        <span className="chx-chip">
                          Cancelled: {Number(bookingsSyncStatus?.summary?.cancelled || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            Number(bookingsSyncStatus?.summary?.errors || 0) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Errors: {Number(bookingsSyncStatus?.summary?.errors || 0)}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={() => handleSetBookingsAutoSyncEnabled(true)}
                          disabled={
                            bookingsSyncUpdating ||
                            bookingsSyncRunning ||
                            Boolean(bookingsRetryingRevisionId) ||
                            bookingsRetryingAll ||
                            bookingsSyncLoading ||
                            (bookingsSyncStatus?.autoSync?.enabled &&
                              bookingsSyncStatus?.webhook?.enabled &&
                              bookingsSyncStatus?.webhook?.webhookId &&
                              bookingsSyncStatus?.webhook?.callbackUrl)
                          }
                        >
                          {bookingsSyncUpdating
                            ? "Saving..."
                            : bookingsSyncStatus?.autoSync?.enabled
                              ? "Repair / Re-register Webhook"
                              : "Enable Real-Time Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => handleSetBookingsAutoSyncEnabled(false)}
                          disabled={
                            bookingsSyncUpdating ||
                            bookingsSyncRunning ||
                            Boolean(bookingsRetryingRevisionId) ||
                            bookingsRetryingAll ||
                            bookingsSyncLoading ||
                            !bookingsSyncStatus?.autoSync?.enabled
                          }
                        >
                          {bookingsSyncUpdating
                            ? "Saving..."
                            : "Disable Real-Time Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn"
                          onClick={handleRunBookingsSync}
                          disabled={
                            bookingsSyncRunning ||
                            bookingsSyncLoading ||
                            bookingsSyncUpdating ||
                            Boolean(bookingsRetryingRevisionId) ||
                            bookingsRetryingAll
                          }
                        >
                          {bookingsSyncRunning ? "Running..." : "Run Manual Sync"}
                        </button>

                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={handleRefreshBookingsAndServices}
                          disabled={
                            bookingsSyncLoading ||
                            bookingsSyncRunning ||
                            bookingsSyncUpdating ||
                            Boolean(bookingsRetryingRevisionId) ||
                            bookingsRetryingAll
                          }
                        >
                          {bookingsSyncLoading ? "Refreshing..." : "Refresh Status"}
                        </button>
                      </div>
                    </div>

                    {bookingsSyncError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {bookingsSyncError}
                      </div>
                    ) : null}

                    {bookingsSyncMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {bookingsSyncMessage}
                      </div>
                    ) : null}

                    <div className="chx-inventoryGrid">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Current State</div>
                          <span
                            className={`chx-chip ${getAutoSyncStatusChipClass(
                              bookingsSyncStatus?.summary?.status || "idle"
                            )}`}
                          >
                            {bookingsSyncStatus?.summary?.status || "idle"}
                          </span>
                        </div>

                        <div className="chx-miniList">
                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Mode</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.autoSync?.enabled
                                ? "Webhook push + backup pull"
                                : "Manual only"}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Webhook callback</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.webhook?.callbackUrl || "Not registered yet."}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Webhook status</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.webhook?.enabled &&
                              bookingsSyncStatus?.webhook?.webhookId &&
                              bookingsSyncStatus?.webhook?.callbackUrl
                                ? "Ready"
                                : "Missing"}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last webhook</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(bookingsSyncStatus?.webhook?.lastReceivedAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last webhook event</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.webhook?.lastEvent || "No webhook received yet."}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last webhook revision</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.webhook?.lastRevisionId || "No revision received yet."}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Backup pull interval</div>
                            <div className="chx-miniRowMeta">
                              {Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) > 0 &&
                              Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) % 60 === 0
                                ? `${Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) / 60} minute${
                                    Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) / 60 === 1
                                      ? ""
                                      : "s"
                                  }`
                                : `${Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0)} second${
                                    Number(bookingsSyncStatus?.autoSync?.backupPullIntervalSeconds || 0) === 1
                                      ? ""
                                      : "s"
                                  }`}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last backup pull</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(
                                bookingsSyncStatus?.autoSync?.lastPollAt ||
                                  bookingsSyncStatus?.summary?.lastPollAt
                              )}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Business Unit</div>
                            <div className="chx-miniRowMeta">
                              {bookingsSyncStatus?.mapping?.businessUnit?.name ||
                                selectedInventoryMapping?.businessUnit?.name ||
                                "Unmapped"}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last successful sync</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(bookingsSyncStatus?.summary?.lastSuccessAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Last batch activity</div>
                            <div className="chx-miniRowMeta">
                              {formatDateTimeLabel(bookingsSyncStatus?.summary?.lastBatchAt)}
                            </div>
                          </div>

                          <div className="chx-miniRow">
                            <div className="chx-miniRowTitle">Latest batch</div>
                            <div className="chx-miniRowMeta">
                              {Array.isArray(bookingsSyncStatus?.recentBatches) &&
                              bookingsSyncStatus.recentBatches.length > 0
                                ? buildBookingsBatchMeta(bookingsSyncStatus.recentBatches[0])
                                : "No booking batches recorded yet."}
                            </div>
                          </div>

                          {bookingsSyncStatus?.summary?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Last error</div>
                              <div className="chx-miniRowMeta">
                                {bookingsSyncStatus.summary.lastError}
                              </div>
                            </div>
                          ) : null}

                          {bookingsSyncStatus?.webhook?.lastError ? (
                            <div className="chx-miniRow">
                              <div className="chx-miniRowTitle">Last webhook error</div>
                              <div className="chx-miniRowMeta">
                                {bookingsSyncStatus.webhook.lastError}
                              </div>
                            </div>
                          ) : null}
                        </div>
                      </div>

                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Recent Batches</div>
                          <span className="chx-chip">
                            {Array.isArray(bookingsSyncStatus?.recentBatches)
                              ? bookingsSyncStatus.recentBatches.length
                              : 0}
                          </span>
                        </div>

                        {bookingsSyncLoading && !bookingsSyncStatus ? (
                          <div className="chx-miniEmpty">Loading booking sync status...</div>
                        ) : Array.isArray(bookingsSyncStatus?.recentBatches) &&
                          bookingsSyncStatus.recentBatches.length > 0 ? (
                          <div className="chx-miniList">
                            {bookingsSyncStatus.recentBatches.map((batch) => (
                              <div className="chx-miniRow" key={`booking-batch-${batch.id}`}>
                                <div className="chx-miniRowTitle">
                                  Batch #{batch.id}{" "}
                                  <span
                                    className={`chx-chip ${getAutoSyncStatusChipClass(batch.status)}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {batch.status}
                                  </span>
                                </div>
                                <div className="chx-miniRowMeta">
                                  {buildBookingsBatchMeta(batch) || "No batch details available."}
                                </div>
                                {batch.lastError ? (
                                  <div className="chx-inlineNote" style={{ color: "#ffb0b0" }}>
                                    {batch.lastError}
                                  </div>
                                ) : null}
                              </div>
                            ))}
                          </div>
                        ) : (
                          <div className="chx-miniEmpty">
                            No booking batches yet. Enable real-time sync or run the
                            feed import manually to pull revisions from Channex.
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="chx-miniPanel" style={{ marginTop: 16 }}>
                      <div className="chx-miniHeader">
                        <div className="chx-miniTitle">Recent Revisions</div>
                        <div className="chx-miniHeaderActions">
                          <input
                            type="text"
                            className="form-control chx-input chx-searchInput"
                            value={bookingsRevisionQuery}
                            onChange={(event) => setBookingsRevisionQuery(event.target.value)}
                            placeholder="Search revisionId, locator, bookingId"
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll
                            }
                          />
                          <span className="chx-chip">
                            {filteredBookingsRevisions.length}/{bookingsRecentRevisions.length}
                          </span>
                          <button
                            type="button"
                            className={`chx-btn chx-btn--secondary ${
                              bookingsRevisionFilter === "all" ? "chx-chip--success" : ""
                            }`}
                            onClick={() => setBookingsRevisionFilter("all")}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll
                            }
                          >
                            All
                          </button>
                          <button
                            type="button"
                            className={`chx-btn chx-btn--secondary ${
                              bookingsRevisionFilter === "errors" ? "chx-chip--error" : ""
                            }`}
                            onClick={() => setBookingsRevisionFilter("errors")}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll
                            }
                          >
                            Errors {bookingsFailedRevisionsCount}
                          </button>
                          <button
                            type="button"
                            className={`chx-btn chx-btn--secondary ${
                              bookingsRevisionFilter === "pending_ack" ? "chx-chip--muted" : ""
                            }`}
                            onClick={() => setBookingsRevisionFilter("pending_ack")}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll
                            }
                          >
                            Pending Ack {bookingsPendingAckRevisionsCount}
                          </button>
                          <button
                            type="button"
                            className={`chx-btn chx-btn--secondary ${
                              bookingsRevisionFilter === "pending" ? "chx-chip--muted" : ""
                            }`}
                            onClick={() => setBookingsRevisionFilter("pending")}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll
                            }
                          >
                            Pending {bookingsPendingRevisionsCount}
                          </button>
                          <button
                            type="button"
                            className="chx-btn"
                            onClick={handleRetryAllFailedBookings}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll ||
                              bookingsBulkReprocessableCount <= 0
                            }
                          >
                            {bookingsRetryingAll ? "Working..." : "Reprocess All Stuck"}
                          </button>
                          <button
                            type="button"
                            className="chx-btn chx-btn--secondary"
                            onClick={handleExportBookingErrors}
                            disabled={
                              bookingsSyncLoading ||
                              bookingsSyncRunning ||
                              bookingsSyncUpdating ||
                              Boolean(bookingsRetryingRevisionId) ||
                              bookingsRetryingAll ||
                              exportableBookingErrorRevisions.length === 0
                            }
                          >
                            Export Errors CSV
                          </button>
                        </div>
                      </div>

                      {bookingsSyncLoading && !bookingsSyncStatus ? (
                        <div className="chx-miniEmpty">Loading booking revisions...</div>
                      ) : filteredBookingsRevisions.length > 0 ? (
                        <div className="chx-miniList">
                          {filteredBookingsRevisions.map((revision) => (
                            <div
                              className={`chx-miniRow ${
                                canRetryBookingRevision(revision)
                                  ? "chx-miniRow--error"
                                  : isPendingAckBookingRevision(revision)
                                    ? "chx-miniRow--pendingAck"
                                    : ""
                              }`}
                              key={`booking-revision-${revision.id}`}
                            >
                              <div className="chx-miniRowTop">
                                <div className="chx-miniRowTitle">
                                  Revision {revision.revisionId}
                                  <span
                                    className={`chx-chip ${getBookingRevisionChipClass(
                                      revision.importStatus
                                    )}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    {revision.importStatus}
                                  </span>
                                  <span
                                    className={`chx-chip ${getBookingRevisionChipClass(
                                      revision.ackStatus
                                    )}`}
                                    style={{ marginLeft: 8 }}
                                  >
                                    Ack {revision.ackStatus}
                                  </span>
                                  {isWebhookTrackedOnlyBookingRevision(revision) ? (
                                    <span
                                      className="chx-chip chx-chip--muted"
                                      style={{ marginLeft: 8 }}
                                    >
                                      Webhook tracked
                                    </span>
                                  ) : null}
                                </div>

                                {canManuallyReprocessBookingRevision(revision) ? (
                                  <button
                                    type="button"
                                    className="chx-btn chx-btn--secondary"
                                    onClick={() => handleRetryBookingRevision(revision)}
                                    disabled={
                                      bookingsSyncRunning ||
                                      bookingsSyncLoading ||
                                      bookingsSyncUpdating ||
                                      Boolean(bookingsRetryingRevisionId) ||
                                      bookingsRetryingAll
                                    }
                                  >
                                    {bookingsRetryingRevisionId === String(revision.revisionId)
                                      ? "Working..."
                                      : getBookingRevisionActionLabel(revision)}
                                  </button>
                                ) : null}
                              </div>
                              <div className="chx-miniRowMeta">
                                {buildBookingRevisionMeta(revision) || "No revision details available."}
                              </div>
                              {isWebhookTrackedOnlyBookingRevision(revision) ? (
                                <div className="chx-inlineNote">
                                  Webhook received and tracked locally. Waiting for revision fetch/import.
                                </div>
                              ) : null}
                              {revision.lastAttemptAt ? (
                                <div className="chx-inlineNote">
                                  Last attempt: {formatDateTimeLabel(revision.lastAttemptAt)}
                                </div>
                              ) : null}
                              {Array.isArray(revision.localReservationIds) &&
                              revision.localReservationIds.length > 0 ? (
                                <div className="chx-inlineNote">
                                  Pilcore reservations: {revision.localReservationIds.join(", ")}
                                </div>
                              ) : null}
                              {Array.isArray(revision.localReservationLocators) &&
                              revision.localReservationLocators.length > 0 ? (
                                <div className="chx-inlineNote">
                                  Pilcore locators: {revision.localReservationLocators.join(", ")}
                                </div>
                              ) : null}
                              {revision.lastError ? (
                                <div className="chx-inlineNote chx-inlineNote--error">
                                  <strong>{getBookingRevisionErrorStageLabel(revision)}:</strong>{" "}
                                  {revision.lastError}
                                </div>
                              ) : null}
                              {Array.isArray(revision.errorHistory) && revision.errorHistory.length > 0 ? (
                                <>
                                  <div className="chx-miniRowActions">
                                    <button
                                      type="button"
                                      className="chx-btn chx-btn--secondary"
                                      onClick={() => toggleBookingRevisionHistory(revision.revisionId)}
                                      disabled={
                                        bookingsSyncLoading ||
                                        bookingsSyncRunning ||
                                        bookingsSyncUpdating ||
                                        Boolean(bookingsRetryingRevisionId) ||
                                        bookingsRetryingAll
                                      }
                                    >
                                      {expandedBookingErrorHistoryByRevision[
                                        String(revision.revisionId)
                                      ]
                                        ? "Hide History"
                                        : `History (${revision.errorHistory.length})`}
                                    </button>
                                  </div>
                                  {expandedBookingErrorHistoryByRevision[
                                    String(revision.revisionId)
                                  ] ? (
                                    <div className="chx-historyList">
                                      {revision.errorHistory.map((entry, index) => (
                                        <div
                                          className="chx-historyEntry"
                                          key={`booking-revision-history-${revision.id}-${index}`}
                                        >
                                          <div className="chx-miniRowMeta" style={{ marginTop: 0 }}>
                                            {[
                                              entry?.at ? formatDateTimeLabel(entry.at) : null,
                                              entry?.stage ? `Stage ${entry.stage}` : null,
                                              entry?.source
                                                ? `Source ${String(entry.source).toUpperCase()}`
                                                : null,
                                              entry?.statusCode != null
                                                ? `HTTP ${entry.statusCode}`
                                                : null,
                                            ]
                                              .filter(Boolean)
                                              .join(" | ") || "Error entry"}
                                          </div>
                                          <div className="chx-inlineNote" style={{ marginTop: 4 }}>
                                            {entry?.message || "No error message recorded."}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : null}
                                </>
                              ) : null}
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="chx-miniEmpty">
                          {bookingsRecentRevisions.length > 0
                            ? "No revisions match the current filter."
                            : "No tracked booking revisions yet. Run the feed import manually or enable auto sync to populate this panel."}
                        </div>
                      )}
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="chx-section">
              <div className="chx-sectionHeader">
                <div className="chx-sectionKicker">Step 10</div>
                <h3 className="chx-sectionTitle">Services / Extras Mapping</h3>
                <div className="chx-sectionSubtitle">
                  Create Channex service mappings before the first booking arrives, keep
                  auto-discovering unknown services from incoming revisions, and reapply
                  mapped extras from tracked bookings whenever you need to backfill.
                </div>
              </div>

              <div className="chx-sectionBody">
                {!selectedInventoryPropertyId ? (
                  <div className="chx-feedback">
                    Select a mapped property first. Service mapping and backfill are
                    stored per Channex property and Business Unit.
                  </div>
                ) : (
                  <>
                    <div className="chx-note">
                      You can create mappings manually here before going live. Channex
                      services discovered from tracked revisions will still appear
                      automatically, and `Reapply Mapped Services` will rebuild
                      `reservation_extras` from the latest stored revision per booking so
                      the first reservation does not get stranded.
                    </div>

                    <div className="chx-toolbar" style={{ marginBottom: 12 }}>
                      <div className="chx-chipRow">
                        <span className="chx-chip">
                          Tracked: {Number(serviceMappingsStatus?.summary?.discovered || 0)}
                        </span>
                        <span className="chx-chip chx-chip--success">
                          Mapped: {Number(serviceMappingsStatus?.summary?.mapped || 0)}
                        </span>
                        <span
                          className={`chx-chip ${
                            Number(serviceMappingsStatus?.summary?.unmapped || 0) > 0
                              ? "chx-chip--error"
                              : "chx-chip--muted"
                          }`}
                        >
                          Unmapped: {Number(serviceMappingsStatus?.summary?.unmapped || 0)}
                        </span>
                        <span className="chx-chip">
                          BU:{" "}
                          {serviceMappingsStatus?.mapping?.businessUnit?.name ||
                            selectedInventoryMapping?.businessUnit?.name ||
                            "Unmapped"}
                        </span>
                      </div>

                      <div className="chx-chipRow">
                        <button
                          type="button"
                          className="chx-btn chx-btn--secondary"
                          onClick={() => loadServiceMappings()}
                          disabled={
                            serviceMappingsLoading ||
                            Boolean(serviceMappingsSavingId) ||
                            serviceMappingsCreating ||
                            serviceMappingsReapplying ||
                            bookingsSyncLoading ||
                            bookingsSyncRunning ||
                            bookingsSyncUpdating
                          }
                        >
                          {serviceMappingsLoading ? "Refreshing..." : "Refresh Services"}
                        </button>
                        <button
                          type="button"
                          className="chx-btn"
                          onClick={handleReapplyPropertyServices}
                          disabled={
                            serviceMappingsLoading ||
                            Boolean(serviceMappingsSavingId) ||
                            serviceMappingsCreating ||
                            serviceMappingsReapplying ||
                            bookingsSyncLoading ||
                            bookingsSyncRunning ||
                            bookingsSyncUpdating ||
                            Number(serviceMappingsStatus?.summary?.mapped || 0) <= 0
                          }
                        >
                          {serviceMappingsReapplying ? "Reapplying..." : "Reapply Mapped Services"}
                        </button>
                      </div>
                    </div>

                    {serviceMappingsError ? (
                      <div className="chx-feedback chx-feedback--error" style={{ marginBottom: 12 }}>
                        {serviceMappingsError}
                      </div>
                    ) : null}

                    {serviceMappingsMessage ? (
                      <div className="chx-feedback chx-feedback--success" style={{ marginBottom: 12 }}>
                        {serviceMappingsMessage}
                      </div>
                    ) : null}

                    <div className="chx-serviceTools">
                      <div className="chx-miniPanel">
                        <div className="chx-miniHeader">
                          <div className="chx-miniTitle">Add Manual Service Mapping</div>
                          <div className="chx-miniHeaderActions">
                            <span className="chx-chip chx-chip--muted">
                              For go-live, before first booking
                            </span>
                          </div>
                        </div>
                        <div className="chx-sectionBody">
                          <div className="chx-serviceFormGrid">
                            <div>
                              <label className="chx-fieldLabel">Channex Service Name</label>
                              <input
                                type="text"
                                className="form-control form-control-sm chx-input"
                                value={manualServiceName}
                                onChange={(event) => setManualServiceName(event.target.value)}
                                placeholder="Breakfast, Parking, City Tax..."
                                disabled={
                                  serviceMappingsLoading ||
                                  Boolean(serviceMappingsSavingId) ||
                                  serviceMappingsCreating ||
                                  serviceMappingsReapplying ||
                                  bookingsSyncLoading ||
                                  bookingsSyncRunning ||
                                  bookingsSyncUpdating
                                }
                              />
                              <div className="chx-inlineNote">
                                Use the Channex service name exactly as it appears in
                                Booking CRS or OTA payloads.
                              </div>
                            </div>

                            <div>
                              <label className="chx-fieldLabel">Scope</label>
                              <select
                                className="form-select form-select-sm chx-input"
                                value={manualServiceScope}
                                onChange={(event) => setManualServiceScope(event.target.value)}
                                disabled={
                                  serviceMappingsLoading ||
                                  Boolean(serviceMappingsSavingId) ||
                                  serviceMappingsCreating ||
                                  serviceMappingsReapplying ||
                                  bookingsSyncLoading ||
                                  bookingsSyncRunning ||
                                  bookingsSyncUpdating
                                }
                              >
                                <option value="booking">booking</option>
                                <option value="room">room</option>
                              </select>
                            </div>

                            <div>
                              <label className="chx-fieldLabel">Pilcore Extra</label>
                              <select
                                className="form-select form-select-sm chx-input"
                                value={manualServiceExtraId}
                                onChange={(event) => setManualServiceExtraId(event.target.value)}
                                disabled={
                                  serviceMappingsLoading ||
                                  Boolean(serviceMappingsSavingId) ||
                                  serviceMappingsCreating ||
                                  serviceMappingsReapplying ||
                                  bookingsSyncLoading ||
                                  bookingsSyncRunning ||
                                  bookingsSyncUpdating
                                }
                              >
                                <option value="">-- Select Extra --</option>
                                {serviceMappingExtras.map((extra) => (
                                  <option key={`chx-manual-extra-${extra.id}`} value={extra.id}>
                                    {extra.name}
                                    {extra.scope ? ` · ${extra.scope}` : ""}
                                    {extra.isActive === false ? " · inactive" : ""}
                                  </option>
                                ))}
                              </select>
                              <div className="chx-inlineNote">
                                You can leave this blank and link it later, although
                                mapping it now is what lets backfill work immediately.
                              </div>
                            </div>

                            <div className="chx-cellAction">
                              <button
                                type="button"
                                className="chx-btn"
                                onClick={handleCreateServiceMapping}
                                disabled={
                                  !String(manualServiceName || "").trim() ||
                                  serviceMappingsLoading ||
                                  Boolean(serviceMappingsSavingId) ||
                                  serviceMappingsCreating ||
                                  serviceMappingsReapplying ||
                                  bookingsSyncLoading ||
                                  bookingsSyncRunning ||
                                  bookingsSyncUpdating
                                }
                              >
                                {serviceMappingsCreating ? "Saving..." : "Create Manual Mapping"}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {serviceMappingsLoading && !serviceMappingsStatus ? (
                      <div className="chx-feedback">Loading tracked Channex services...</div>
                    ) : discoveredChannexServices.length > 0 ? (
                      <div className="chx-table">
                        <div className="chx-tableHeader">
                          <div>Channex Service</div>
                          <div>Details</div>
                          <div>Pilcore Extra</div>
                          <div>Seen / Status</div>
                        </div>
                        {discoveredChannexServices.map((serviceMapping) => (
                          <div className="chx-tableRow" key={`chx-service-${serviceMapping.id}`}>
                            <div>
                              <div className="chx-tableTitle">{serviceMapping.serviceName}</div>
                              <div className="chx-tableMeta">
                                Scope {serviceMapping.scope}
                                {serviceMapping.serviceType
                                  ? ` | Type ${serviceMapping.serviceType}`
                                  : ""}
                              </div>
                            </div>

                            <div>
                              <div className="chx-tableMeta">
                                {[
                                  serviceMapping.priceMode
                                    ? `Mode ${serviceMapping.priceMode}`
                                    : null,
                                  serviceMapping.sampleTotalPrice != null
                                    ? `Sample ${serviceMapping.sampleTotalPrice.toFixed(2)} ${
                                        serviceMapping.sampleCurrency || ""
                                      }`.trim()
                                    : null,
                                ]
                                  .filter(Boolean)
                                  .join(" | ") || "No sample pricing yet."}
                              </div>
                            </div>

                            <div>
                              <select
                                className="form-select form-select-sm chx-input"
                                value={serviceMapping.extraId || ""}
                                onChange={(event) =>
                                  handleSaveServiceMapping(
                                    serviceMapping.id,
                                    event.target.value ? Number(event.target.value) : null
                                  )
                                }
                                disabled={
                                  serviceMappingsLoading ||
                                  Boolean(serviceMappingsSavingId) ||
                                  serviceMappingsCreating ||
                                  serviceMappingsReapplying ||
                                  bookingsSyncLoading ||
                                  bookingsSyncRunning ||
                                  bookingsSyncUpdating
                                }
                              >
                                <option value="">-- Select Extra --</option>
                                {serviceMappingExtras.map((extra) => (
                                  <option key={`chx-extra-${extra.id}`} value={extra.id}>
                                    {extra.name}
                                    {extra.scope ? ` · ${extra.scope}` : ""}
                                    {extra.isActive === false ? " · inactive" : ""}
                                  </option>
                                ))}
                              </select>
                            </div>

                            <div>
                              <div className="chx-tableMeta">
                                {formatDateTimeLabel(serviceMapping.lastSeenAt)}
                              </div>
                              <div className="chx-inlineNote" style={{ marginTop: 4 }}>
                                {serviceMapping.extra
                                  ? `Mapped to ${serviceMapping.extra.name}`
                                  : "Not mapped yet"}
                              </div>
                              {serviceMappingsSavingId === String(serviceMapping.id) ? (
                                <div className="chx-inlineNote" style={{ marginTop: 4 }}>
                                  Saving...
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="chx-feedback">
                        No Channex services have been tracked yet for this property. You
                        can still create a manual mapping above before the first booking
                        arrives, or let Channex discover services from incoming revisions
                        later.
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ChannexIntegrationCard;
